// Sample audits - REAL LinkedIn profile snapshots, byte-identical to a real user audit.
// Generated by scripts/build-sample-audits.js from snapshots produced by
// scripts/snapshot-sample-audits.js (which calls the production scrape + AI pipeline).
//
// Personas: 3 real public LinkedIn creators (Matt Lakajev, Lara Acosta, Justin Welsh).
// Their LinkedIn profiles are public; analyzing them publicly is fair use.
// Their auditResults match exactly what a paying user would see in the Dashboard.
//
// To regenerate: node scripts/snapshot-sample-audits.js && node scripts/build-sample-audits.js

const SAMPLES = [
 {
 "id": "matt-lakajev",
 "meta": {
 "headline": "Build Your LinkedIn AI Second Brain - Starting 11th of May - DM me “BRAIN” for the details",
 "persona": "Matt Lakajev · LinkedIn educator · 111K followers · Sydney",
 "score": 61
 },
 "profileUrl": "https://www.linkedin.com/in/mattlakajev/",
 "questionnaireData": {
 "fullName": "Matt Lakajev",
 "role": "LinkedIn personal-brand educator + founder",
 "industry": "Creator economy / B2B sales education",
 "audience": "B2B founders, sales leaders, and consultants who want inbound on LinkedIn",
 "goal": "Grow inbound for my LinkedIn personal-brand course business",
 "tone": "Confident, direct, founder-y",
 "biggestRecentImpact": "Sold 1000+ seats of a LinkedIn personal-brand course built on top of my own profile growth playbook",
 "notes": "Profile is my biggest funnel. Want to make sure every section converts."
 },
 "scrapedData": {
 "avatar": "https://media.licdn.com/dms/image/v2/D5603AQFL3qViNzol3Q/profile-displayphoto-crop_800_800/B56ZuInIB3JYAI-/0/1767523574063?e=1779926400&v=beta&t=1MGmv3nGOAq4lrGr1ar7G3jfqEsaVJ25otmLjmcdtZg",
 "profile_picture_url": "https://media.licdn.com/dms/image/v2/D5603AQFL3qViNzol3Q/profile-displayphoto-crop_800_800/B56ZuInIB3JYAI-/0/1767523574063?e=1779926400&v=beta&t=1MGmv3nGOAq4lrGr1ar7G3jfqEsaVJ25otmLjmcdtZg",
 "background_picture_url": "https://media.licdn.com/dms/image/v2/D5616AQE2XvqVq2laEw/profile-displaybackgroundimage-shrink_350_1400/B56Z34CQ5mGoAY-/0/1777982838659?e=1779926400&v=beta&t=mBR4QDvognxzXlDskW7G5piT9L_njBH9UvkcC0iwcYo",
 "banner_image": "https://media.licdn.com/dms/image/v2/D5616AQE2XvqVq2laEw/profile-displaybackgroundimage-shrink_350_1400/B56Z34CQ5mGoAY-/0/1777982838659?e=1779926400&v=beta&t=mBR4QDvognxzXlDskW7G5piT9L_njBH9UvkcC0iwcYo",
 "name": "Matt Lakajev",
 "fullname": "Matt Lakajev",
 "first_name": "Matt",
 "last_name": "Lakajev",
 "headline": "Build Your LinkedIn AI Second Brain - Starting 11th of May - DM me “BRAIN” for the details",
 "position": "Build Your LinkedIn AI Second Brain - Starting 11th of May - DM me “BRAIN” for the details",
 "public_identifier": "mattlakajev",
 "about": "",
 "city": "Greater Sydney Area",
 "country": "Australia",
 "country_code": "AU",
 "location": "Greater Sydney Area",
 "followers": 111374,
 "connections": 26999,
 "follower_count": 111374,
 "connection_count": 26999,
 "is_creator": true,
 "is_premium": true,
 "is_influencer": false,
 "open_to_work": false,
 "current_company": "Seven Figure Creators",
 "current_company_url": "https://www.linkedin.com/company/seven-figure-creators",
 "creator_hashtags": [
 "ai",
 "contentmarketing",
 "linkedin",
 "personalbranding",
 "sales"
 ],
 "top_skills": [
 "Making It Rain On LinkedIn"
 ],
 "experience": [
 {
 "title": "Chief Making It Rain On LinkedIn Officer",
 "company": "Seven Figure Creators",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQEBK-pbhwE5qw/company-logo_400_400/company-logo_400_400/0/1729058360095/seven_figure_creators_logo?e=1779926400&v=beta&t=Zfz_kD3tfKs0PLdpADUZJSncWFv5Ofn0tnzsdHmiAuI",
 "duration": "Nov 2025 - Present · 7 mos",
 "location": "Hybrid",
 "employment_type": "Full-time",
 "company_linkedin_url": "https://www.linkedin.com/company/89843136/",
 "description": "",
 "start_date": {
 "month": "Nov",
 "year": 2025
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": []
 },
 {
 "title": "Co-Founder",
 "company": "Seven Figure Creators",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQEBK-pbhwE5qw/company-logo_400_400/company-logo_400_400/0/1729058360095/seven_figure_creators_logo?e=1779926400&v=beta&t=Zfz_kD3tfKs0PLdpADUZJSncWFv5Ofn0tnzsdHmiAuI",
 "duration": "Nov 2022 - Nov 2025 · 3 yrs 1 mo",
 "location": "",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/89843136/",
 "description": "",
 "start_date": {
 "month": "Nov",
 "year": 2022
 },
 "end_date": {
 "month": "Nov",
 "year": 2025
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Host",
 "company": "How to Make Money as a Creator",
 "company_logo_url": "",
 "duration": "Jun 2024 - Present · 2 yrs",
 "location": "Sydney, New South Wales, Australia",
 "employment_type": "Full-time",
 "company_linkedin_url": "https://www.linkedin.com/company/104141040/",
 "description": "99% of LinkedIn content is trash.\n\nI’m sick of the same “PC” noise.\n\nBroke “brand gurus” telling broke creators how to “win.”\n\nAnd real business owners are listening?\n\nThat’s wild. So I decided to launch my podcast\n\n👉 How to Make Money on LinkedIn 👈\n\nNo fluff-just real strategies.\n\nI’ve been posting 3 times a day, but that’s still not enough.\n\nSo I decided to go HAM and record a podcast EVERY SINGLE DAY.\n\nBusiness Owners. This is for you.",
 "start_date": {
 "month": "Jun",
 "year": 2024
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": []
 },
 {
 "title": "Host",
 "company": "The AI Sales Revolution",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQGxa3isWWr0HA/company-logo_400_400/company-logo_400_400/0/1695522395181/the_ai_sales_revolution_logo?e=1779926400&v=beta&t=GtaCJkgSdc8Q5rEu7VSUHZFeCjowoZQ672msr-Nr55U",
 "duration": "Jan 2023 - Present · 3 yrs 5 mos",
 "location": "Sydney, New South Wales, Australia",
 "employment_type": "Full-time",
 "company_linkedin_url": "https://www.linkedin.com/company/90414135/",
 "description": "",
 "start_date": {
 "month": "Jan",
 "year": 2023
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": []
 },
 {
 "title": "Co-Founder",
 "company": "Seven Figure Creators (7FC)",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQGMQ3fn4yDouA/company-logo_400_400/B56ZfoA3feHUAY-/0/1751944231759?e=1779926400&v=beta&t=DkjYdbOTmzS3SLpoU8nZrdm6IYMqQce0mVChv8j_Y9M",
 "duration": "Nov 2022 - Present · 3 yrs 7 mos",
 "location": "Sydney, New South Wales, Australia",
 "employment_type": "Full-time",
 "company_linkedin_url": "https://www.linkedin.com/company/107801445/",
 "description": "",
 "start_date": {
 "month": "Nov",
 "year": 2022
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": []
 },
 {
 "title": "Member",
 "company": "BNI CBD Corporate",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/C4D0BAQErctejQcAPzw/company-logo_400_400/company-logo_400_400/0/1630531300763?e=1779926400&v=beta&t=lXJHcsGqOBm7pXS3wn1WCJ1pLKIRibZNU-HVey0mZkU",
 "duration": "Feb 2023 - Jun 2024 · 1 yr 5 mos",
 "location": "Sydney, New South Wales, Australia",
 "employment_type": "Part-time",
 "company_linkedin_url": "https://www.linkedin.com/company/67261211/",
 "description": "",
 "start_date": {
 "month": "Feb",
 "year": 2023
 },
 "end_date": {
 "month": "Jun",
 "year": 2024
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Member",
 "company": "Pavilion",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D4E0BAQEp82fIJV1meg/company-logo_400_400/company-logo_400_400/0/1707410857633/join_pavilion_logo?e=1779926400&v=beta&t=8TTqgNAb3t2OTHgJb0Dog3KIHP7ZkKWeuSaGQZ0jjgM",
 "duration": "Feb 2022 - Aug 2023 · 1 yr 7 mos",
 "location": "Sydney, New South Wales, Australia",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/27062956/",
 "description": "",
 "start_date": {
 "month": "Feb",
 "year": 2022
 },
 "end_date": {
 "month": "Aug",
 "year": 2023
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Co-Founder",
 "company": "Tele-sense Advisory",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQGWqWVDlQ9y3g/company-logo_400_400/company-logo_400_400/0/1719979002478/tele_sense_logo?e=1779926400&v=beta&t=KYs9WtSfyWe_2oTwz47KQKQ5b0gJCMn52QmyfWGA7WM",
 "duration": "Jun 2022 - Feb 2023 · 9 mos",
 "location": "Sydney, New South Wales, Australia",
 "employment_type": "Full-time",
 "company_linkedin_url": "https://www.linkedin.com/company/74947204/",
 "description": "Tele-Sense Advisory is a consulting firm that makes sure you're paying what's fair for your communications.\n\nTo date we have worked with over 150 organisations and on average have saved them 48% on their total spend.\n\nIf you are interested in discussing how we could potentially help, please do not hesitate to contact us.\n\nEmail - Contact@tele-sense.com.au\nPhone Number - 1300 124 557",
 "start_date": {
 "month": "Jun",
 "year": 2022
 },
 "end_date": {
 "month": "Feb",
 "year": 2023
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Account Executive",
 "company": "Clari",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQFA-1jcghT1jQ/company-logo_400_400/company-logo_400_400/0/1738948074602/clari_logo?e=1779926400&v=beta&t=mcTwvoQH8BM4xEmRlWkDPbQeQ9y1Z_8prK9dGWpGHbU",
 "duration": "Apr 2022 - Jun 2022 · 3 mos",
 "location": "Sydney, New South Wales, Australia",
 "employment_type": "Full-time",
 "company_linkedin_url": "https://www.linkedin.com/company/2706103/",
 "description": "Clari’s Revenue Operations Platform improves efficiency, predictability, and growth across the entire revenue process. Clari gives revenue teams total visibility into their business, to drive process rigor, spot risk and opportunity in the pipeline, increase forecast accuracy, and drive overall efficiency. Thousands of sales, marketing, and customer success teams at leading companies, including Okta, Adobe, Workday, Zoom, and Finastra, use Clari’s execution insights to make their revenue process more connected, efficient, and predictable. Visit us at clari.com and follow us @clari on LinkedIn.",
 "start_date": {
 "month": "Apr",
 "year": 2022
 },
 "end_date": {
 "month": "Jun",
 "year": 2022
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Commercial Account Executive",
 "company": "Zoom",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQHdFe3fnAvRmg/company-logo_400_400/company-logo_400_400/0/1711361750580/zoom_video_communications_logo?e=1779926400&v=beta&t=jVMzSM_kMTB54fog23FW56v-YuKt74B_IvfvDAaS-Ko",
 "duration": "Jan 2022 - Apr 2022 · 4 mos",
 "location": "Sydney, New South Wales, Australia",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/2532259/",
 "description": "",
 "start_date": {
 "month": "Jan",
 "year": 2022
 },
 "end_date": {
 "month": "Apr",
 "year": 2022
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "SMB Account Executive",
 "company": "Zoom",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQHdFe3fnAvRmg/company-logo_400_400/company-logo_400_400/0/1711361750580/zoom_video_communications_logo?e=1779926400&v=beta&t=jVMzSM_kMTB54fog23FW56v-YuKt74B_IvfvDAaS-Ko",
 "duration": "Aug 2020 - Jan 2022 · 1 yr 6 mos",
 "location": "Sydney, New South Wales, Australia",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/2532259/",
 "description": "",
 "start_date": {
 "month": "Aug",
 "year": 2020
 },
 "end_date": {
 "month": "Jan",
 "year": 2022
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Senior Online Account Executive",
 "company": "Zoom",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQHdFe3fnAvRmg/company-logo_400_400/company-logo_400_400/0/1711361750580/zoom_video_communications_logo?e=1779926400&v=beta&t=jVMzSM_kMTB54fog23FW56v-YuKt74B_IvfvDAaS-Ko",
 "duration": "Apr 2020 - Aug 2020 · 5 mos",
 "location": "Sydney, New South Wales, Australia",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/2532259/",
 "description": "",
 "start_date": {
 "month": "Apr",
 "year": 2020
 },
 "end_date": {
 "month": "Aug",
 "year": 2020
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Online Account Executive",
 "company": "Zoom",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQHdFe3fnAvRmg/company-logo_400_400/company-logo_400_400/0/1711361750580/zoom_video_communications_logo?e=1779926400&v=beta&t=jVMzSM_kMTB54fog23FW56v-YuKt74B_IvfvDAaS-Ko",
 "duration": "Apr 2019 - Apr 2020 · 1 yr 1 mo",
 "location": "Sydney, Australia",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/2532259/",
 "description": "",
 "start_date": {
 "month": "Apr",
 "year": 2019
 },
 "end_date": {
 "month": "Apr",
 "year": 2020
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Accountant",
 "company": "Shaw Downie Chartered Accountants",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQEdZYZ2EhnO5g/company-logo_400_400/company-logo_400_400/0/1666821104579/shaw_downie_logo?e=1779926400&v=beta&t=h-J0R_wwut5dRrce6fSyoQofORVvqTfzHXAuO0yiPVw",
 "duration": "Jun 2017 - Apr 2019 · 1 yr 11 mos",
 "location": "Sydney, Australia",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/1181327/",
 "description": "",
 "start_date": {
 "month": "Jun",
 "year": 2017
 },
 "end_date": {
 "month": "Apr",
 "year": 2019
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Co-Founder",
 "company": "Little box coffee pty ltd",
 "company_logo_url": "",
 "duration": "Oct 2015 - Jul 2017 · 1 yr 10 mos",
 "location": "",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/search/results/all/?keywords=Little+box+coffee+pty+ltd",
 "description": "",
 "start_date": {
 "month": "Oct",
 "year": 2015
 },
 "end_date": {
 "month": "Jul",
 "year": 2017
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Coffee training consultant",
 "company": "Matthew lakajev coffee training",
 "company_logo_url": "",
 "duration": "Jan 2014 - Jul 2017 · 3 yrs 7 mos",
 "location": "Sydney, Australia",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/search/results/all/?keywords=Matthew+lakajev+coffee+training",
 "description": "",
 "start_date": {
 "month": "Jan",
 "year": 2014
 },
 "end_date": {
 "month": "Jul",
 "year": 2017
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Head barista",
 "company": "Coffee Brothers",
 "company_logo_url": "",
 "duration": "Nov 2011 - Aug 2015 · 3 yrs 10 mos",
 "location": "Mona Vale, New South Wales, Australia",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/12357968/",
 "description": "",
 "start_date": {
 "month": "Nov",
 "year": 2011
 },
 "end_date": {
 "month": "Aug",
 "year": 2015
 },
 "is_current": false,
 "skills": []
 }
 ],
 "education": [
 {
 "school": "Swinburne University of Technology",
 "degree": "Bachelor of Business, Accounting",
 "degree_name": "Bachelor of Business",
 "field_of_study": "Accounting",
 "duration": "2017 - 2019",
 "school_linkedin_url": "https://www.linkedin.com/company/8987/",
 "description": "",
 "activities": "",
 "skills": [],
 "school_logo_url": "https://media.licdn.com/dms/image/v2/C560BAQGDauPopGFBCg/company-logo_400_400/company-logo_400_400/0/1631329617302?e=1779926400&v=beta&t=LsxNflkUxJO-ZDRzQXFcCuo9i6eCTzE8uWYX-ErIwsI",
 "start_date": {
 "year": 2017,
 "month": null
 },
 "end_date": {
 "year": 2019,
 "month": null
 }
 },
 {
 "school": "Sydney Institute of Business and Technology (SIBT)",
 "degree": "Advanced diploma of Commerce",
 "degree_name": "Advanced diploma of Commerce",
 "field_of_study": "",
 "duration": "2014 - 2017",
 "school_linkedin_url": "https://www.linkedin.com/company/15140486/",
 "description": "",
 "activities": "",
 "skills": [],
 "school_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQFyo4WK7PHD7g/company-logo_400_400/company-logo_400_400/0/1727322805499/sydney_institute_of_business_and_technology_sibt__logo?e=1779926400&v=beta&t=pT3rcGnGgkkwpHKQi6FHgFvSDyz6CM6KRhn8RWkq870",
 "start_date": {
 "year": 2014,
 "month": null
 },
 "end_date": {
 "year": 2017,
 "month": null
 }
 }
 ],
 "skills": [
 {
 "name": "Making It Rain On LinkedIn",
 "endorsement_count": 57,
 "related_experiences": [
 "Co-Founder at Seven Figure Creators"
 ]
 },
 {
 "name": "New Business Development",
 "endorsement_count": 0,
 "related_experiences": [
 "Endorsed by 2 colleagues at Pavilion"
 ]
 },
 {
 "name": "Sales Prospecting",
 "endorsement_count": 89,
 "related_experiences": [
 "Endorsed by 2 colleagues at Zoom"
 ]
 },
 {
 "name": "Artificial Intelligence (AI)",
 "endorsement_count": 30,
 "related_experiences": []
 },
 {
 "name": "Customer Service",
 "endorsement_count": 41,
 "related_experiences": []
 },
 {
 "name": "Sales Processes",
 "endorsement_count": 26,
 "related_experiences": []
 },
 {
 "name": "Sales Operations",
 "endorsement_count": 16,
 "related_experiences": []
 },
 {
 "name": "Strategic Consulting",
 "endorsement_count": 14,
 "related_experiences": []
 },
 {
 "name": "Leadership",
 "endorsement_count": 15,
 "related_experiences": []
 },
 {
 "name": "Telecommunications",
 "endorsement_count": 9,
 "related_experiences": []
 },
 {
 "name": "Consulting",
 "endorsement_count": 9,
 "related_experiences": []
 },
 {
 "name": "Change Management",
 "endorsement_count": 6,
 "related_experiences": []
 },
 {
 "name": "Business Advisory Services",
 "endorsement_count": 8,
 "related_experiences": []
 },
 {
 "name": "Business Analysis",
 "endorsement_count": 6,
 "related_experiences": []
 },
 {
 "name": "Teamwork",
 "endorsement_count": 9,
 "related_experiences": []
 }
 ],
 "certifications": [],
 "featured": [],
 "languages": [],
 "volunteering": [],
 "recommendations_received": [
 {
 "recommender_name": "Stefan Auerbach",
 "recommender_title": "Pre-Deployment Reviews for AI Agents | Helping Founders Ship Without Hidden Liability | 32+ Years in Cybersecurity",
 "recommender_profile_id": "ACoAAAC0qO0BIHt5RJJXeVU6JPmeQP8lnCY2Vko",
 "recommendation_date": "December 6, 2025",
 "relationship": "Stefan was Matt’s client",
 "recommendation_text": "I've always been a bit skeptical about sales programs from well-known creators. Honestly, when I first started following Matt in January 2025, he seemed like many internet gurus out ther, showing flashy cars and bragging about success. You know, the usual story of hitting rock bottom, then having a sudden realization on a bathroom floor.\n\nBut as time went on, I noticed a pattern. Matt's approach was always straightforward and genuine. He consistently shared practical tools and showcased real customer success stories every day. That made me want to pay closer attention. Recently, I joined his free Black Friday workshop, and that's when everything truly clicked.\n\nIt became clear: this guy is truly authentic. His systems, programs, and community are filled with smart, motivated people all aiming for the same goal, success on LinkedIn. \n\nThe respect he shows his clients and customers is remarkable, and he mixes in a great sense of humor that really connects with people. I felt an instant connection with him, and I know others did too.\n\nOver the years, I’ve tried about 50 different programs, but this one stands out. Matt has nailed the system, and people are genuinely getting results. Personally, his tools are already transforming how I think and act in very positive ways.\n\nWhat I appreciate most is Matt’s genuine desire to see people succeed. This isn’t just a typical guru story, he’s a real, down-to-earth person who has poured his heart and soul into creating something valuable for LinkedIn members.\n\nNow, I wholeheartedly recommend Matt and his program. He’s truly excellent at what he does, and his success speaks for itself.\n\nI have nothing but praise for Matt and hope he continues on this inspiring journey. LinkedIn is fortunate to have someone like him, people like Matt really make a platform stand out!"
 },
 {
 "recommender_name": "Jasmine Arora",
 "recommender_title": "$68M (AED 250M) Sold in 3 years | Real Estate Consultant | Helping real estate agents build self filling pipeline | Author | Seven Figure Agents Community | Pilates princess 😂",
 "recommender_profile_id": "ACoAACE1Lf0BnvrHipH5FuRxhfUsiTO4Dy0Ht94",
 "recommendation_date": "October 13, 2025",
 "relationship": "Jasmine was Matt’s client",
 "recommendation_text": "Matt’s level of fast action always inspires me. \nHe genuinely cares about helping people grow, both personally and professionally.\n\nI’ve learned so much from him (and continue to learn!) his insights have made a real impact on my real estate coaching business."
 },
 {
 "recommender_name": "Kinga Vajda",
 "recommender_title": "If the buck stops with you, you own the pendulum | Finding decision points before they break your system | IKINGAI™",
 "recommender_profile_id": "ACoAABVZUyUBanPJRMgk3XrhI_e4Qzomjl2Bo-A",
 "recommendation_date": "August 13, 2025",
 "relationship": "Kinga worked with Matt but on different teams",
 "recommendation_text": "Matt gave us an outstanding 2 hour workshop in Chris Do's FuturPro Group! He was so genuine and engaging from the start - making sure to tailor the content around our needs. Everything was centered around people's needs; aligned with clear values and acknowledging truth and trust systems. It didn't matter what position you hold - the content was relevant and relatable. He gave us tangible advice, and used methods to visualize the thought process. We have plenty of tools to walk away with, & 'aha' moments. Great content and delivery. Thanks Matt for your kindness! 🌟🌟🌟🌟🌟"
 },
 {
 "recommender_name": "Garrett Dresen, CFP®",
 "recommender_title": "Financial freedom from your business: Build wealth, scale smart, and exit on your terms.",
 "recommender_profile_id": "ACoAACkz59YB4kyPlci66ApelNZ5UmFVklB0O9o",
 "recommendation_date": "June 6, 2025",
 "relationship": "Garrett was Matt’s client",
 "recommendation_text": "Matt provided me so much up front value without asking for anything. He has a ton of knowledge specifically for financial planners creating a LinkedIn system to generate leads. Thanks Matt! "
 },
 {
 "recommender_name": "Varun C.",
 "recommender_title": "Making LinkedIn great (and fun) again.",
 "recommender_profile_id": "ACoAADJS-18BfkJ3fTOQeOWwC6xmjDkN2ySrFpY",
 "recommendation_date": "December 11, 2024",
 "relationship": "Varun was Matt’s client",
 "recommendation_text": "I haven't paid Matt a single penny.\n\nI have never worked with him.\n\nYou must be wondering, why is this guy here?\n\nI'm here to spread the truth.\n\nTHE TRUTH about business and sales that flows through Matt's mouth...\n\nand how powerfully he makes you think about transforming your ideas into a business.\n\nThe framework he gives you inside his free email course is the best free stuff I have ever seen in my life for anyone to start their lead generating journey on LinkedIn.\nAND I HAVE ZERO DOUBTS ABOUT IT.\n\nHe SHOULD have asked me for my money for it.\n\nThe amount of ideas he equips you with, the way you get a voice about your offer, the idea of a pitch deck and how much easier it makes your life when you are just starting to pitch a service.\n\nALL these are MONUMENTAL to take a business from scratch to a GOOD START.\n\nAnd the truth he speaks about reaching out, the process he showcases to get your foot into the door for better opportunities, by building relationships through a real logical system🤌🏻🤌🏻🤌🏻\n\n(it's on YouTube, if you are missing it out)\n\nFOLLOW THIS GUY ON YOUTUBE, PEOPLE!\n\nHis stuff is a hidden goldmine and I'm digging through to get every trinket I can get my meaty paws on.\n\nMASSIVE RESPECT, MY MAN!\n\nHATS OFF🎩, LEGEND!"
 },
 {
 "recommender_name": "Abu Nayeem",
 "recommender_title": "Helping Founders Build Authority & Attract the Right Audience on LinkedIn through LinkedIn Profile Optimization, Rebranding (Visual Design + Copy), and Proven Client Acquisition Strategies.",
 "recommender_profile_id": "ACoAACF0KfsBpglWEmBFtrVGVqP_9gdqYs8jPnU",
 "recommendation_date": "March 6, 2024",
 "relationship": "Abu was Matt’s client",
 "recommendation_text": "It was a great pleasure when I got Matthew's voice note with some epic advice.\nHe viewed my LinkedIn profile and advised me on how I can set my CTA link that generates leads.\nI also engaged with his helpful newsletter, which includes step-by-step guidelines with video and text.\n\nIf anyone likes to quality leads and sell by chat. I recommend contacting Matthew.\nHe is amicable and cooperative in helping people."
 },
 {
 "recommender_name": "Audrey Chia",
 "recommender_title": "Building Brands that Convert | Positioning + Strategy + Copywriting | Human X AI Workflows | To God Be The Glory 💛",
 "recommender_profile_id": "ACoAABr3h8cBFYTO_JBh-rZfB7wEjkyA2Zwg3VE",
 "recommendation_date": "October 11, 2023",
 "relationship": "Audrey worked with Matt but they were at different companies",
 "recommendation_text": "Mindblowing madness. Matthew is one of those incredibly smart and talented folks who has combined the best of tactical sales knowledge with optimised AI execution. \n\nI’m a conversion copywriter and I can tell that his sales strategy and process really hits home. It’s smart, effective and highly efficient. \n\nUnlockAI is one of those courses that absolutely cannot miss. I’m sure it will 10X your growth and make your sales process 100X less painful. Just check out his content, you won’t regret it."
 },
 {
 "recommender_name": "David Hayes",
 "recommender_title": "Babeltext.AI - Bridging Language Gaps in Global Customer Service = Open New Markets",
 "recommender_profile_id": "ACoAAABTD_wBTKynuj4ZPZn5FqIaJ0vs2h4GScI",
 "recommendation_date": "October 11, 2023",
 "relationship": "David was Matt’s client",
 "recommendation_text": "When you need to learn how AI can help you generate sales - ASK MATT - He is incredibly professional and impressive. Just launched a new package and well worth checking out. David Hayes Founder Babeltext"
 },
 {
 "recommender_name": "Sean McHugh",
 "recommender_title": "I help pubs get finance and fill them with business owners",
 "recommender_profile_id": "ACoAABImR4QBzOb0h0HViwMnuovBuXnM9AOCNrM",
 "recommendation_date": "October 5, 2023",
 "relationship": "Sean was Matt’s client",
 "recommendation_text": "I used to spend 1-2 hours on a Sunday writing a post. Now AI does it for me in 20 seconds and I only spend 5 minutes editing it to produce high quality content. Working with Matt has helped me unlock the ultimate productivity hack to grow and scale my business. Thank you so much Matt, I appreciate you!"
 },
 {
 "recommender_name": "Didarul Khan",
 "recommender_title": "Registered Company Auditor I Creating financial transparency for businesses and investors through strategic auditing",
 "recommender_profile_id": "ACoAAAOFV_gB6sQ4i9ZVcMJnZnJ2R6Oq7iOT3xI",
 "recommendation_date": "September 4, 2023",
 "relationship": "Didarul was Matt’s client",
 "recommendation_text": "I had the pleasure of working with Matt during a 6-week course on artificial intelligence. As an AI guru, Matt's depth of knowledge and practical application of AI tools are unparalleled. His guidance was instrumental in not only helping me understand the intricacies of AI but also in maximizing my LinkedIn presence. Working with Matt was both educational and enjoyable. I highly recommend him for any projects that require a deep understanding of AI and its practical applications."
 },
 {
 "recommender_name": "Balaji V",
 "recommender_title": "Helping ‘solopreneurs’ build a 6-Figure Hero Brand Plan.",
 "recommender_profile_id": "ACoAAAMXty4BcCtRD09osuU4HgzZx8weyWsBsVE",
 "recommendation_date": "August 30, 2023",
 "relationship": "Balaji worked with Matt on the same team",
 "recommendation_text": "From my very first conversation with Matthew, I could connect with his passion and respect for quality work.\n\nMatthew’s vision of linking AI to LinkedIn sales + his approach were so novel and deep.\n\nI’m someone who has great standards; I’m very choosy about who I want to work with. The pace at which our association has grown has been a happy surprise for me.\n\nWhat I see now is amazing. Wait and see in 6 months → our association is going to become an industry hit.\n\nMatthew is very systems-driven; he has great empathy for creative minds like mine. This helps me feel safe, as I hold my creative skills with great respect.\n\nYour grand vision is one of the best → folks Matthew is amazing; don’t forget to connect with him."
 },
 {
 "recommender_name": "Max Rascher",
 "recommender_title": "Global Gen AI Trainer & Keynote Speaker | Adjunct Professor of AI | 2x CEO & Founder | Helping You Leverage AI in the Workplace",
 "recommender_profile_id": "ACoAACw5niYBvD0BOPe9s2M0dPuvKlSf9-xi0-Q",
 "recommendation_date": "August 6, 2023",
 "relationship": "Max worked with Matt on the same team",
 "recommendation_text": "I haven't met anyone as in-tune with sales psychology as Matthew. This man knows his stuff, and he isn't interested in keeping it all to himself! A certified GEM to follow on LinkedIn 🏅"
 },
 {
 "recommender_name": "Jessie Lizak",
 "recommender_title": "Helping B2B Founders & Execs Build Personal Brands with Livestreaming, Podcasting and Ai | Reveting's WinsDay Host | Fractional CMO | Deconstructing Data Co-Host | Marketing Coach | Retreat Host",
 "recommender_profile_id": "ACoAAAPRy6QB2Ws6rlfHIXTSwzTuizOkK4e28xY",
 "recommendation_date": "August 2, 2023",
 "relationship": "Jessie and Matt studied together",
 "recommendation_text": "I enthusiastically endorse Matthew Lakajev, whose intelligence, sales acumen, and AI expertise shone brightly during his recent appearance on Whiskey WinsDay. Matthew's engaging personality and ability to simplify complex ideas make him a compelling communicator and captivating guest.\n\nMatthew’s deep understanding of both Sales and AI is remarkable. His aptitude for interconnecting these two seemingly disparate areas showcased his creative thinking. His insights into the potential of AI in transforming sales were intriguing and inspiring, speaking volumes of his business acumen and knowledge of AI.\n\nHis passion for his subject matter is both palpable and infectious. Combined with his natural leadership skills and excellent communication abilities, he is a dynamic force in any team setting or discussion. His contributions in Sales and AI are invaluable, and his presence would significantly enhance any project or endeavor in these fields.\n\nIn summary, Matthew Lakajev comes with my highest recommendation. His blend of intelligence, personality, and expertise would be a fantastic addition to any initiative within the sales and AI industries."
 },
 {
 "recommender_name": "Alistair Irving",
 "recommender_title": "3x Presidents Club - Senior Account Executive @ Huntress",
 "recommender_profile_id": "ACoAABxvc6cBwFEGBZwhS21l4fgh4EDigIOz338",
 "recommendation_date": "July 19, 2023",
 "relationship": "Matt was senior to Alistair but didn't manage Alistair directly",
 "recommendation_text": "Matt's work ethic is truly commendable. He is undoubtedly one of the hardest working individuals I have come across. Regardless of the challenges that arose, Matt remained dedicated, focused, and driven to achieve outstanding results. His commitment to delivering high-quality work is a testament to his passion for what he does.\n\nDuring my tenure at Zoom, I had the privilege of benefiting from Matt's mentorship. As a mentor, Matt possesses a rare combination of patience, approachability, and an ability to explain complex concepts in a clear and understandable manner. He genuinely cares about the growth and development of his peers, and his guidance has had a lasting positive impact on my professional journey.\n\nIn addition to his mentoring skills, Matt is exceptionally knowledgeable in the field of AI. His insights into the latest trends, advancements, and the future of AI were truly impressive. I often turned to Matt for advice and guidance in this rapidly evolving domain, and he never failed to provide valuable perspectives and recommendations."
 },
 {
 "recommender_name": "Sohaib Albadawee",
 "recommender_title": "Build your personal monopoly",
 "recommender_profile_id": "ACoAAAuURocBb0a7chT8l6ZxQudtFa930Q_wfBU",
 "recommendation_date": "July 3, 2023",
 "relationship": "Sohaib worked with Matt but on different teams",
 "recommendation_text": "Matthew has built a unique monopoly within the intersection of AI and Sales.\n\nThe quality of his content on LinkedIn and podcasts is superb.\n\nIf you're interested to learn about the world of AI & Sales, Matthew is your guy."
 },
 {
 "recommender_name": "Ubaid Ur Rehman",
 "recommender_title": "Design Guy Loved By the Top 1% | DM “Design” to Get Started.",
 "recommender_profile_id": "ACoAACoMEBkBtNqjNrXijopDuhurxCNzeRPEjFI",
 "recommendation_date": "July 2, 2023",
 "relationship": "Ubaid was Matt’s teacher",
 "recommendation_text": "I met Matthew on LinkedIn for the first time when he started posting about AI tools.\n\nIt was really fascinating for me to see how AI can be embedded in our day to day life.\n\nAfter a few months, he reached out me for his LinkedIn profile transformation.\n\nWe jumped on call, talked his:\n\n- ICP he wants to attract.\n- Long terms LinkedIn goals.\n- How he wants to be positioned.\n\nAfter completing the initial stage I shared the following with Matt:\n\n1. Profile Headline\n2. About Copy\n\nHe instantly approved it. ✅\n\nNext we worked on the visual part to add life to the profile:\n\n1. Banner with his mission.\n2. A contrasting headshot.\n3. Featured Covers to stand out.\n\nI’m happy to call him a good friend now.\n\nAnd excited for next opportunities with him."
 },
 {
 "recommender_name": "Priyanka Sundhar",
 "recommender_title": "Startup GTM Consultant | 2x First Sales Hire ($0 → $3M ARR)",
 "recommender_profile_id": "ACoAACs275UBtNQYN-QERjch0h_7XXdrPYKO7eQ",
 "recommendation_date": "June 22, 2023",
 "relationship": "Priyanka worked with Matt but they were at different companies",
 "recommendation_text": "Matt has an incredible perspective on sales process, sales technology and where we're headed with AI. I learn from him every time we connect whether it's around personality & sales, cold outreach tactics, a unique way to leverage Chat-GPT or a new AI tool to adopt. \n\nI would recommend him to any startup or business who wants to level up their sales and close more revenue!"
 },
 {
 "recommender_name": "Jono Ngo",
 "recommender_title": "Biz Dev | 2x P Club | 1x Lucky Exit | Comme des Garçons → cold calls | Posting real stuff, no coaching bs, no bots | Make LinkedIn lol again | Generated 300k impressions in 60 days, it’s all a game | Follow @somuchsaas",
 "recommender_profile_id": "ACoAABGLuqcBKghEqSXKlPqXMZ2BunrdLMfZGjE",
 "recommendation_date": "June 21, 2023",
 "relationship": "Jono worked with Matt but on different teams",
 "recommendation_text": "Reliable, innovative and efficient are three ways I would describe Matt. He cares about his customers and relationships, and is passionate about helping them succeed. \nKeep up the energy mate. \nAlways be competitive ;)\nPs. Goa was nuts "
 },
 {
 "recommender_name": "Michael Newman",
 "recommender_title": "Director at Tele-Sense ",
 "recommender_profile_id": "ACoAACRMIaABjvK6yNgYJ-GSLusN-0q6r64_pZ0",
 "recommendation_date": "June 20, 2023",
 "relationship": "Michael worked with Matt on the same team",
 "recommendation_text": "Matt came into the business and just attached a rocket to our sales process - Results: In 5 months we booked 150 meetings, closed 26 deals and closed close to $1 million in contract value"
 },
 {
 "recommender_name": "Chris Lansing",
 "recommender_title": "Drive engineering clarity. Deliver consistently.",
 "recommender_profile_id": "ACoAABWxUXIB4k3kF8H-l21Z6o1Dr6n4H-_gM6I",
 "recommendation_date": "June 20, 2023",
 "relationship": "Chris was Matt’s client",
 "recommendation_text": "Matt resembles the best of what sales roles can offer, he was there to help with no other motive, he was sincere, and genuine, put time and effort in making a personalized video, and although we never lined up a contract, he offered to help anyway and also introduced me to someone who can. Stand up professional, it pains me to admit, but this is what the sales profession can aspire to get back to."
 }
 ],
 "recommendations_count": 20,
 "honors_and_awards": [],
 "basic_info": {
 "fullname": "Matt Lakajev",
 "first_name": "Matt",
 "last_name": "Lakajev",
 "headline": "Build Your LinkedIn AI Second Brain - Starting 11th of May - DM me “BRAIN” for the details",
 "public_identifier": "mattlakajev",
 "profile_url": "https://linkedin.com/in/mattlakajev",
 "profile_picture_url": "https://media.licdn.com/dms/image/v2/D5603AQFL3qViNzol3Q/profile-displayphoto-crop_800_800/B56ZuInIB3JYAI-/0/1767523574063?e=1779926400&v=beta&t=1MGmv3nGOAq4lrGr1ar7G3jfqEsaVJ25otmLjmcdtZg",
 "about": "",
 "location": {
 "country": "Australia",
 "city": "Greater Sydney Area",
 "full": "Greater Sydney Area",
 "country_code": "AU"
 },
 "creator_hashtags": [
 "ai",
 "contentmarketing",
 "linkedin",
 "personalbranding",
 "sales"
 ],
 "is_creator": true,
 "is_influencer": false,
 "is_premium": true,
 "open_to_work": false,
 "created_timestamp": 1448001101798,
 "show_follower_count": true,
 "background_picture_url": "https://media.licdn.com/dms/image/v2/D5616AQE2XvqVq2laEw/profile-displaybackgroundimage-shrink_350_1400/B56Z34CQ5mGoAY-/0/1777982838659?e=1779926400&v=beta&t=mBR4QDvognxzXlDskW7G5piT9L_njBH9UvkcC0iwcYo",
 "urn": "ACoAABuHSCUBL9DCSWU-f1rf-MhZOXTD-3EQMM0",
 "follower_count": 111374,
 "connection_count": 26999,
 "current_company": "Seven Figure Creators",
 "current_company_urn": "89843136",
 "current_company_url": "https://www.linkedin.com/company/seven-figure-creators",
 "top_skills": [
 "Making It Rain On LinkedIn"
 ],
 "email": null
 }
 },
 "auditResults": {
 "overallScore": 61,
 "maxScore": 100,
 "sections": {
 "profilePicture": {
 "score": 8,
 "maxScore": 10,
 "current": "Professional headshot present and loaded from LinkedIn CDN.",
 "optimized": [
 "For your ICP - \"B2B founders, sales leaders, and consultants who want inbound on LinkedIn\" - the visual code is 'peer operator' not 'guru influencer'; they read credibility in authentic workspace context.",
 "As a LinkedIn personal-brand educator with 111,374 followers and host of two shows, your photo should signal 'operator + creator' (someone who executes systems, not just talks).",
 "Your current photo URL exists; the gap is signalling operator expertise (workspace, subtle prop, composed but not overly styled)."
 ],
 "suggestions": [
 "Replace headshot with a workspace crop: upper-chest to top-of-head, slight left tilt, background shows a laptop and podcast mic (signals creator-operator).",
 "Wear a dark merino quarter-zip over a plain tee - founders and sales leaders read that as 'peer operator', not 'guru'.",
 "Use a mid-thought direct gaze (not staged smile) - founders want an operator who looks like they ship, not pose.",
 "Crop for mobile: 800×800 square, subject offset 40% left so banner text on the right remains visible."
 ],
 "priority": "low"
 },
 "banner": {
 "score": 7,
 "maxScore": 10,
 "current": "Custom banner detected.",
 "optimized": [
 "Your banner must stop a founder in 1-2 seconds by showing one concrete proof (the 150 meetings / ~$1M result) paired with your method name 'LinkedIn AI Second Brain'.",
 "Because you run daily content and two podcasts, the banner should act as a proof billboard (result + method + CTA) rather than a decorative image.",
 "Your current banner URL exists; the gap is it doesn't use that single, highest-leverage line of proof."
 ],
 "suggestions": [
 "Put this hero line on the banner, left-justified: \"$1M pipeline & 150 meetings booked in 5 months - LinkedIn AI Second Brain\"",
 "Add CTA text bottom-right: \"DM 'BRAIN' for starter kit\" in 28pt white on dark navy, signal green accent #00C389",
 "Feature proof badge top-right: \"111k followers\" in white on signal green circle (40px diameter)",
 "Use Canva template 'Creator Banner Pro' 1584×396px, dark navy background, left hero line at 72pt, right-side empty for headshot bleed"
 ],
 "priority": "medium"
 },
 "headline": {
 "score": 7,
 "maxScore": 10,
 "current": "Current headline: \"Build Your LinkedIn AI Second Brain - Starting 11th of May - DM me “BRAIN” for the details\"",
 "optimized": [
 "A high-converting headline for your positioning names the ICP verbatim (B2B founders, sales leaders, and consultants), names the outcome (predictable inbound), and anchors it to your method 'LinkedIn AI Second Brain'.",
 "Your current headline sells an event; the gap is audience + outcome clarity that gets cold visitors to pause and believe you help their specific problem."
 ],
 "suggestions": [
 "I help B2B founders, sales leaders & consultants turn LinkedIn into predictable inbound - creator of the LinkedIn AI Second Brain (111k followers). DM “BRAIN”",
 "Creator of the LinkedIn AI Second Brain | I help B2B founders, sales leaders & consultants automate content, conversations and booked meetings (150 meetings, ~$1M pipeline)",
 "Inbound LinkedIn for B2B founders, sales leaders & consultants - stop cold outreach: AI + system that writes, engages and books meetings. DM “BRAIN” to join"
 ],
 "priority": "medium"
 },
 "about": {
 "score": 0,
 "maxScore": 10,
 "current": "About section is empty - top opportunity for inbound conversion.",
 "optimized": [
 "The About section must be a 5-block mini-sales page aimed at B2B founders, sales leaders & consultants: hook → problem → bridge (your method) → proof → CTA.",
 "Your proof should surface two things above the fold: follower trust (111k) and a client metric (150 meetings, ~$1M) so sceptical founders convert quickly.",
 "Your current profile has no About; the gap is a missing narrative that ties your podcast, UnlockAI/free course, and client outcomes into one offer."
 ],
 "suggestions": "Most B2B founders, sales leaders and consultants treat LinkedIn like a to-do list-posting, praying, and still waiting for clients. I build a different system: the LinkedIn AI Second Brain - an AI+process stack that writes your best content, engages prospects, and turns conversation into booked meetings.\n\nYou’re busy. You don’t want to spend eight hours a week on posts or send cold DMs. You want a predictable inbound pipeline that shows up in your calendar. That’s the gap I close. My approach combines AI prompt engineering, repeatable copy templates (from UnlockAI and my free email course), and a playbook for converting comments into meetings.\n\nProof lives in results: my audience of 111,374 followers is an active testing ground, and clients have seen decisive outcomes - in one engagement we booked 150 meetings, closed 26 deals and generated nearly $1M in contract value. I run two shows (How to Make Money on LinkedIn and The AI Sales Revolution) and reuse that content to validate every playbook I teach.\n\nIf you’re a B2B founder, sales leader or consultant who wants real inbound (not vanity metrics), DM \"BRAIN\" to get the LinkedIn AI Second Brain starter kit (free 5-email course + 3 prompt templates). If you’re ready to jump straight to a demo, reply \"CALL\" and I’ll send a Calendly link.",
 "priority": "high"
 },
 "profileUrl": {
 "score": 9,
 "maxScore": 10,
 "current": "Custom URL: linkedin.com/in/mattlakajev",
 "optimized": [
 "Your URL is linkedin.com/in/mattlakajev - already custom and memorable; use it consistently across signatures and QR codes.",
 "Because your headline uses DM CTA, your custom URL is better used for cross-platform links and Calendly pages than as a headline element."
 ],
 "suggestions": [
 "Add to email signature exactly: \"Matt Lakajev - linkedin.com/in/mattlakajev - DM 'BRAIN' for the LinkedIn AI Second Brain\"",
 "Create a QR card linking to https://linkedin.com/in/mattlakajev and place it on your podcast cover and business card (URL encoded in QR).",
 "Paste https://linkedin.com/in/mattlakajev in your Twitter/X bio, YouTube channel About, and the footer of sevenfigurecreators.com",
 "DM example: \"Hey - sending this so you can see my AI templates: https://linkedin.com/in/mattlakajev - DM 'BRAIN' if you want the starter kit.\"",
 "Five-minute action: add your custom URL to your Calendly, email footer, and Twitter bio right now."
 ],
 "priority": "low"
 },
 "toneAndCohesion": {
 "score": 8,
 "maxScore": 10,
 "current": "Tone consistency evaluated across headline, About, and Experience sections.",
 "optimized": [
 "Across headline, experience, and featured you need one repeating phrase: 'LinkedIn AI Second Brain' - that phrase must appear in headline, banner, About and current role description.",
 "Right now your experience lists multiple roles (7FC co-founder, podcast host) which supports creator authority, but the gap is lack of single narrative that connects them to the productized service.",
 "Featured must contain proof + lead magnet + CTA in that order so all sections tell the same conversion story."
 ],
 "suggestions": [
 "Fix Headline + Banner + Current Role first - sync them to repeat 'LinkedIn AI Second Brain' and the Michael Newman proof line.",
 "Use the exact phrase 'LinkedIn AI Second Brain' in headline, banner, About first paragraph, and current role description for cohesion.",
 "Condense older unrelated roles (Coffee training, Head barista) to a single 'Early career: hospitality (2011-2017)' line in Experience.",
 "Replace any event-first language (your current 'Starting 11th of May') with outcome-first language across sections.",
 "10-minute check: open your profile in an incognito window and verify the phrase 'LinkedIn AI Second Brain' appears in headline, banner, About, and current role."
 ],
 "priority": "low"
 },
 "recommendations": {
 "score": 9,
 "maxScore": 10,
 "current": "20 recommendations on profile from peers and clients.",
 "optimized": [
 "You already have strong, recent recommendations from clients (Stefan Auerbach, Jasmine Arora, Michael Newman) - that’s high leverage for authority.",
 "The remaining gap is case-study style recommendations that name the specific outcome language you use on the banner (meetings, deals, pipeline)."
 ],
 "suggestions": [
 "Ask these people first for outcome-focused lines: Michael Newman, Jasmine Arora, Stefan Auerbach (they’re recent, ICP-matching recommenders).",
 "Message Michael: \"Michael - could you add one line about the 150 meetings / ~$1M result? Happy to draft - Matt\"",
 "Ask recommenders to mention measurable outcomes: meetings booked, deals closed, pipeline value (e.g., \"150 meetings, 26 deals, ~$1M\").",
 "Offer to draft the recommendation: \"Happy to draft a short paragraph you can tweak - keeps it easy and quick.\"",
 "Request 2 recommendations per week until you have 5 that explicitly state outcomes and role (Founder / Sales Leader / Consultant)."
 ],
 "priority": "low"
 },
 "experience": {
 "score": 6,
 "maxScore": 10,
 "current": "17 roles listed. Current: Chief Making It Rain On LinkedIn Officer at Seven Figure Creators.",
 "optimized": [
 "Your current role titles ('Chief Making It Rain On LinkedIn Officer', Co-Founder Seven Figure Creators) are attention-grabbing but lack outcome-focused descriptions with metrics.",
 "Older roles (barista, coffee training) are valid but should be condensed so the Experience section supports your creator/GTM offer.",
 "Attach media (podcast episodes, UnlockAI excerpt, Black Friday workshop) to your current role to convert curious visitors into leads."
 ],
 "suggestions": [
 "Replace current role description with: \"Built LinkedIn AI Second Brain - automated content, conversations & calendar booking; clients booked 150 meetings, closed 26 deals (~$1M).\"",
 "Upload media to current role: one podcast episode clip, UnlockAI excerpt, and Black Friday workshop recording (mp4 or SoundCloud link).",
 "Condense Tele-sense Advisory to: \"Tele-sense Advisory - reduced communications spend by 48% across 150+ orgs (2019-2023).\"",
 "Move coffee roles into single line: \"Early career - hospitality & training (2011-2017)\" to avoid distracting founders.",
 "Swap power verb 'managed' for 'scaled' or 'generated' in role bullets (e.g., 'Generated 150 meetings in 5 months')."
 ],
 "priority": "medium"
 },
 "honorsAndAwards": {
 "score": 1,
 "maxScore": 10,
 "current": "No honors or awards on profile.",
 "optimized": "AI did not return optimization for this section.",
 "suggestions": [],
 "priority": "high"
 },
 "educationAndCertification": {
 "score": 6,
 "maxScore": 10,
 "current": "2 education entries listed.",
 "optimized": [
 "Your Bachelor of Business (Accounting) supports commercial credibility but is not directly persuasive for a LinkedIn AI product - the gap is recent, relevant certifications or programs.",
 "A short continuous-learning signal (e.g., certificate or 'UnlockAI' flagship course featured) would tie education to your current AI+LinkedIn authority."
 ],
 "suggestions": [
 "Add a short course credential: 'UnlockAI - Creator Course' or 'AI for Sales - [course name]' on certifications.",
 "Condense older education entries into a single line with years and keep Swinburne Bachelor of Business (Accounting) visible.",
 "Feature one continuous-learning signal: add 'Pavilion member' with dates (you were a Pavilion member Feb 2022-Aug 2023) as professional development."
 ],
 "priority": "medium"
 }
 },
 "prioritizedActions": [
 {
 "title": "The About section must be a 5-block mini-sales page aimed at B2B founders, sales leaders &",
 "description": "The About section must be a 5-block mini-sales page aimed at B2B founders, sales leaders & consultants: hook → problem → bridge (your method) → proof → CTA.",
 "timeEstimate": "30-60 min",
 "priority": "high",
 "category": "about",
 "impact": "+3-5 points"
 },
 {
 "title": "Optimize honors & awards",
 "description": "Apply AI suggestions to improve honors & awards.",
 "timeEstimate": "30-60 min",
 "priority": "high",
 "category": "honorsAndAwards",
 "impact": "+3-5 points"
 },
 {
 "title": "Your current role titles ('Chief Making It Rain On LinkedIn Officer', Co-Founder Seven Fig",
 "description": "Your current role titles ('Chief Making It Rain On LinkedIn Officer', Co-Founder Seven Figure Creators) are attention-grabbing but lack outcome-focused descriptions with metrics.",
 "timeEstimate": "15-30 min",
 "priority": "medium",
 "category": "experience",
 "impact": "+1-2 points"
 },
 {
 "title": "Your Bachelor of Business (Accounting) supports commercial credibility but is not directly",
 "description": "Your Bachelor of Business (Accounting) supports commercial credibility but is not directly persuasive for a LinkedIn AI product - the gap is recent, relevant certifications or programs.",
 "timeEstimate": "15-30 min",
 "priority": "medium",
 "category": "educationAndCertification",
 "impact": "+1-2 points"
 },
 {
 "title": "Your banner must stop a founder in 1-2 seconds by showing one concrete proof (the 150 meet",
 "description": "Your banner must stop a founder in 1-2 seconds by showing one concrete proof (the 150 meetings / ~$1M result) paired with your method name 'LinkedIn AI Second Brain'.",
 "timeEstimate": "15-30 min",
 "priority": "medium",
 "category": "banner",
 "impact": "+1-2 points"
 }
 ],
 "weeklyPlan": [
 {
 "week": 1,
 "focus": "High-impact fixes",
 "tasks": [
 "Rewrite About",
 "Rewrite awards"
 ],
 "expectedGain": "+8-12 points"
 },
 {
 "week": 2,
 "focus": "Polish + depth",
 "tasks": [
 "Refine banner",
 "Refine headline",
 "Refine experience",
 "Refine education"
 ],
 "expectedGain": "+5-8 points"
 },
 {
 "week": 3,
 "focus": "Sustained signal",
 "tasks": [
 "Maintain photo",
 "Maintain URL",
 "Maintain tone",
 "Ship one outcome-led post per week",
 "Cross-link Featured to About CTAs"
 ],
 "expectedGain": "+3-5 points"
 }
 ]
 }
 },
 {
 "id": "lara-acosta",
 "meta": {
 "headline": "Entrepreneur and speaker building businesses online | Forbes 30u30 | Helped 3,000+ people grow their personal brand and scale their business",
 "persona": "Lara Acosta · Founder + LinkedIn educator · 330K followers · Forbes 30u30",
 "score": 81
 },
 "profileUrl": "https://www.linkedin.com/in/laraacostar/",
 "questionnaireData": {
 "fullName": "Lara Acosta",
 "role": "Founder + LinkedIn educator",
 "industry": "Creator economy / personal branding",
 "audience": "Solopreneurs and founders building personal brands on LinkedIn",
 "goal": "Continue scaling my personal-brand course + community",
 "tone": "Warm, opinionated, founder-y",
 "biggestRecentImpact": "Grew to 200K+ LinkedIn followers and built a 7-figure personal-brand business in under three years",
 "notes": "Profile drives all my organic inbound. Optimization compounds."
 },
 "scrapedData": {
 "avatar": "https://media.licdn.com/dms/image/v2/D4E03AQEfwO2tv6ef4A/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1686093441109?e=1779926400&v=beta&t=kQFzGU0rjQ8rqa7Y7dJUoMaTHGei7So4kHpdZT1LgTE",
 "profile_picture_url": "https://media.licdn.com/dms/image/v2/D4E03AQEfwO2tv6ef4A/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1686093441109?e=1779926400&v=beta&t=kQFzGU0rjQ8rqa7Y7dJUoMaTHGei7So4kHpdZT1LgTE",
 "background_picture_url": "https://media.licdn.com/dms/image/v2/D4E16AQGGwksybvuaeA/profile-displaybackgroundimage-shrink_350_1400/B4EZx5jLsYH0AY-/0/1771565792830?e=1779926400&v=beta&t=4DYWkCa9ULyOrvTVcQk--WilRIPx-yzTu8SCmkjc6aY",
 "banner_image": "https://media.licdn.com/dms/image/v2/D4E16AQGGwksybvuaeA/profile-displaybackgroundimage-shrink_350_1400/B4EZx5jLsYH0AY-/0/1771565792830?e=1779926400&v=beta&t=4DYWkCa9ULyOrvTVcQk--WilRIPx-yzTu8SCmkjc6aY",
 "name": "Lara Acosta",
 "fullname": "Lara Acosta",
 "first_name": "Lara",
 "last_name": "Acosta",
 "headline": "Entrepreneur and speaker building businesses online | Forbes 30u30 | Helped 3,000+ people grow their personal brand and scale their businesses.",
 "position": "Entrepreneur and speaker building businesses online | Forbes 30u30 | Helped 3,000+ people grow their personal brand and scale their businesses.",
 "public_identifier": "laraacostar",
 "about": "Everyone wants to build a personal brand, and I figured out how.\n\nWith over 20M+ impressions, 300,000 followers across socials, and multiple 6 figures made, I can show you how you can build one too (without spending years figuring out how)\n\nIn 2022: I was unemployed and trying to get into a master's degree - downloaded LinkedIn\nIn 2023: I became #1 female creator on LinkedIn by building my personal brand and agency\nIn 2024: I'm building the best education platform to teach people exactly how to do it\n\nHelped, coached and worked with 500+ build contents systems, increase engagement, improve their writing and beyond using proven strategies that worked for me. \n\nHere's how I can help you:\n\n1. Subscribe to my YouTube (It's free, and better than people's paid courses!)\n2. Join 15,100+ amazing people and subscribe to my newsletter. \n3. Join 500+ members inside Literallyacademy.com\n\nAnd if you're not ready for either! Welcome to my profile anyway, I talk about writing, storytelling, personal branding and tell a lot of stories.\n\nSee you on the feed 💖\n\nSponsorships + booking : mary@ladigitalmx.com or laraacosta@sixteenth.com",
 "city": "London, England",
 "country": "United Kingdom",
 "country_code": "GB",
 "location": "London, England, United Kingdom",
 "followers": 329718,
 "connections": 7649,
 "follower_count": 329718,
 "connection_count": 7649,
 "is_creator": true,
 "is_premium": true,
 "is_influencer": false,
 "open_to_work": false,
 "current_company": "Literally Academy",
 "current_company_url": "https://www.linkedin.com/company/literally-academy",
 "creator_hashtags": [
 "copywriting",
 "entrepreneurship",
 "linkedin",
 "personalbranding"
 ],
 "top_skills": [
 "Personal Branding",
 "Content Marketing",
 "Copywriting"
 ],
 "experience": [
 {
 "title": "Co-founder ",
 "company": "Kleo",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D4E0BAQHq0fm8ZCPB8Q/company-logo_400_400/company-logo_400_400/0/1698907830473/kleoso_logo?e=1779926400&v=beta&t=Ob28BlDVarioTIxR4hhpgMZ0kjwqwmPd7Hp5yzW62Ik",
 "duration": "Mar 2025 - Present · 1 yr 3 mos",
 "location": "London Area, United Kingdom",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/100115698/",
 "description": "",
 "start_date": {
 "month": "Mar",
 "year": 2025
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": []
 },
 {
 "title": "Founder",
 "company": "Literally Academy",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D4E0BAQHBa1x7pKJPyA/company-logo_400_400/company-logo_400_400/0/1728852657528?e=1779926400&v=beta&t=C-6VuW4ypua5gEnoHXnfb6vsejcd60P13_8UgKlXeqs",
 "duration": "Sep 2024 - Present · 1 yr 9 mos",
 "location": "London Area, United Kingdom",
 "employment_type": "Full-time",
 "company_linkedin_url": "https://www.linkedin.com/company/105260514/",
 "description": "Changing the education system one step at a time. \n\nAn academy for entrepreneurs and CEO's giving you every blueprint necessary to build, scale and grow your business through content on LinkedIn (and beyond).\n\n- Full a-z curriculim with netflix quality videos \n- Monthly Live calls to answer any questions\n- Monthly challenges and prizes for members\n- A community to hold you accountable weekly \n\nIncluding Masterclasses by the 0.01% of creators and entrepreneurs. \n\nFeaturing: Richard Moore, Dakota Robertson, JK Molina + others. \n\n3,000+ members and counting.\n\nIt's time to build your brand.",
 "start_date": {
 "month": "Sep",
 "year": 2024
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": [
 "LinkedIn",
 "Personal Branding",
 "Content Marketing",
 "Content Strategy"
 ]
 },
 {
 "title": "Founder",
 "company": "LA Digital",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D4E0BAQFhsO7dTzeu7Q/company-logo_400_400/company-logo_400_400/0/1686086024164/digital_la_logo?e=1779926400&v=beta&t=MjF7GKg5NrUSp9d5UnvQyXAIAVAN17KMUcQP1F_nRU4",
 "duration": "Apr 2022 - Present · 4 yrs 2 mos",
 "location": "Remote",
 "employment_type": "Full-time",
 "company_linkedin_url": "https://www.linkedin.com/company/80430194/",
 "description": "Ghostwriting agency building viral personal brands on LinkedIn.",
 "start_date": {
 "month": "Apr",
 "year": 2022
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": [
 "Copywriting",
 "Marketing Strategy",
 "Personal Branding",
 "Positioning (Marketing)",
 "Entrepreneurship"
 ]
 },
 {
 "title": "Angel Investor",
 "company": "Neutonic",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQE_e5lniFIHRg/company-logo_400_400/B56ZZeqNVhHsAY-/0/1745344846058/drinkneutonic_logo?e=1779926400&v=beta&t=pEuoD1rx6EK-YrG-OJpQTWH-2HSF90MqxfjSMxVD7ZI",
 "duration": "Jun 2025 - Present · 1 yr",
 "location": "",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/103459286/",
 "description": "",
 "start_date": {
 "month": "Jun",
 "year": 2025
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": []
 }
 ],
 "education": [
 {
 "school": "University of Exeter",
 "degree": "Master of Science - MS, Digital Marketing",
 "degree_name": "Master of Science - MS",
 "field_of_study": "Digital Marketing",
 "duration": "Sep 2022 - Sep 2023",
 "school_linkedin_url": "https://www.linkedin.com/company/11826/",
 "description": "Grade: Merit",
 "activities": "",
 "skills": [],
 "school_logo_url": "https://media.licdn.com/dms/image/v2/D4E0BAQFaqA3xUyurLQ/company-logo_400_400/company-logo_400_400/0/1719821579475/university_of_exeter_logo?e=1779926400&v=beta&t=sridoaUEtg9ElR2WUWpGAiBBl1X4-2q9NyaRYPZUDYo",
 "start_date": {
 "year": 2022,
 "month": "Sep"
 },
 "end_date": {
 "year": 2023,
 "month": "Sep"
 }
 },
 {
 "school": "Coventry University",
 "degree": "Bachelor's degree, International Business Management ",
 "degree_name": "Bachelor's degree",
 "field_of_study": "International Business Management",
 "duration": "Aug 2016 - Aug 2019",
 "school_linkedin_url": "https://www.linkedin.com/company/15492/",
 "description": "",
 "activities": "",
 "skills": [],
 "school_logo_url": "https://media.licdn.com/dms/image/v2/D4E0BAQFpumhep48D1A/company-logo_400_400/company-logo_400_400/0/1688197183058/coventry_university_logo?e=1779926400&v=beta&t=KmkJCvT9qULVYHLK5mvNYv-7G4S8SJNvU-u7YsM1vAI",
 "start_date": {
 "year": 2016,
 "month": "Aug"
 },
 "end_date": {
 "year": 2019,
 "month": "Aug"
 }
 },
 {
 "school": "Wellington School",
 "degree": "A-Levels",
 "degree_name": "A-Levels",
 "field_of_study": "",
 "duration": "2014 - 2016",
 "school_linkedin_url": "https://www.linkedin.com/company/7050038/",
 "description": "",
 "activities": "",
 "skills": [],
 "school_logo_url": "https://media.licdn.com/dms/image/v2/C4D0BAQE1NwDUfyiZQg/company-logo_400_400/company-logo_400_400/0/1630516324668/wellington_school_logo?e=1779926400&v=beta&t=uh6hapCmk_1dMV1kpgpfNymPFnWkOHjEAZpH2cfMQg0",
 "start_date": {
 "year": 2014,
 "month": null
 },
 "end_date": {
 "year": 2016,
 "month": null
 }
 }
 ],
 "skills": [
 {
 "name": "LinkedIn",
 "endorsement_count": 13,
 "related_experiences": [
 "Founder at Literally Academy"
 ]
 },
 {
 "name": "Personal Branding",
 "endorsement_count": 50,
 "related_experiences": [
 "2 experiences across Literally Academy and 1 other company"
 ]
 },
 {
 "name": "Entrepreneurship",
 "endorsement_count": 0,
 "related_experiences": [
 "Founder at LA Digital",
 "Endorsed by Lisa Winning and 1 other who is highly skilled at this"
 ]
 },
 {
 "name": "Marketing Strategy",
 "endorsement_count": 87,
 "related_experiences": [
 "Founder at LA Digital"
 ]
 },
 {
 "name": "Positioning (Marketing)",
 "endorsement_count": 31,
 "related_experiences": [
 "Founder at LA Digital"
 ]
 },
 {
 "name": "Public Speaking",
 "endorsement_count": 31,
 "related_experiences": []
 },
 {
 "name": "Copywriting",
 "endorsement_count": 44,
 "related_experiences": [
 "Founder at LA Digital"
 ]
 },
 {
 "name": "Content Marketing",
 "endorsement_count": 15,
 "related_experiences": [
 "Founder at Literally Academy"
 ]
 },
 {
 "name": "Marketing",
 "endorsement_count": 90,
 "related_experiences": []
 },
 {
 "name": "Social Media",
 "endorsement_count": 89,
 "related_experiences": []
 },
 {
 "name": "Market Research",
 "endorsement_count": 28,
 "related_experiences": []
 },
 {
 "name": "Teamwork",
 "endorsement_count": 25,
 "related_experiences": []
 },
 {
 "name": "Digital Marketing",
 "endorsement_count": 29,
 "related_experiences": []
 },
 {
 "name": "Brand Strategy",
 "endorsement_count": 29,
 "related_experiences": []
 },
 {
 "name": "Content Strategy",
 "endorsement_count": 29,
 "related_experiences": [
 "Founder at Literally Academy"
 ]
 },
 {
 "name": "Graphic Design",
 "endorsement_count": 21,
 "related_experiences": []
 },
 {
 "name": "Creative Consultation",
 "endorsement_count": 26,
 "related_experiences": []
 },
 {
 "name": "Branding & Identity",
 "endorsement_count": 28,
 "related_experiences": []
 },
 {
 "name": "Negotiation",
 "endorsement_count": 23,
 "related_experiences": []
 },
 {
 "name": "Facebook Marketing",
 "endorsement_count": 22,
 "related_experiences": []
 },
 {
 "name": "Strategic Partnerships",
 "endorsement_count": 26,
 "related_experiences": []
 }
 ],
 "certifications": [],
 "featured": [
 {
 "type": "link",
 "title": "Starting May 17th",
 "description": "theknownclub.com",
 "url": "https://www.theknownclub.com/cohort-3-application-offer?",
 "image_url": "https://media.licdn.com/dms/image/v2/D4E2DAQFqe37B3-mQXg/profile-treasury-image-shrink_8192_8192/B4EZ3_MrgdJcAk-/0/1778103008666?e=1778846400&v=beta&t=Fn-WckdMC0UZWXYwjmbWUUuP4F85Z-_IHd5tUfy_ZrE"
 }
 ],
 "languages": [],
 "volunteering": [],
 "recommendations_received": [
 {
 "recommender_name": "Charlotte Lloyd",
 "recommender_title": "Helping high performing founders close premium B2B/B2C clients + grow with buyer-led selling, high trust closing, lead gen + AI. │ 23 years in B2B sales to building my business │ 3x Top Global Saleswoman (DemandBase)",
 "recommender_profile_id": "ACoAAADOPJQB7l-8QzlLLakyzwniGVVVhvruunk",
 "recommendation_date": "November 24, 2024",
 "relationship": "Charlotte and Lara studied together",
 "recommendation_text": "Lara is LITERALLY the best.\n\nI have accompanied her journey for the last 1.5 years and in October I had the pleasure of hosting a LinkedIn Audio with her. We brought the house down! She brings the magic, the fire, the queen of slay.\n\nShe really knows on a deeper level not just what makes people tick here, but how to nail \"beyond nailing\" psychology, content, branding, marketing. Most of all, building a loyal community in which people can learn from her every day. \n\nI am excited to see what you do next and proud to call you a bestie."
 },
 {
 "recommender_name": "Hugh Meyer, MBA",
 "recommender_title": "Real Estate’s Financial Planner | USA Today’s Top Financial Advisory Firms 2025, 2026 | Wealth Strategy Aligned With Your Greater Purpose| 25 Years Demystifying Retirement|",
 "recommender_profile_id": "ACoAAA_FCF8BR-LvNCBqzygivvsKVMmVSNpFGQY",
 "recommendation_date": "November 19, 2024",
 "relationship": "Hugh was Lara’s client",
 "recommendation_text": "Lara Acosta is an exceptional human being and coach. \n\nLara is easily the most giving individual on the platform. Her process, consistency and dedication to teach others how to build brands and be successful is of the highest order.Lara has an incredible library of knowledge and experience to build a brand here or anywhere!\n\nLara continues to be an amazing supporter of my work. I would recommend Lara to anyone, no matter the stage they are in on the platform.\n\nHappy to call Lara a great friend!"
 },
 {
 "recommender_name": "Tasleem Ahmad Fateh",
 "recommender_title": "I supply words to the rich and busy.",
 "recommender_profile_id": "ACoAACrPvFwByhKNdXwBppmONYxgnw7_8ltX05k",
 "recommendation_date": "January 22, 2024",
 "relationship": "Tasleem Ahmad and Lara studied together",
 "recommendation_text": "Lara is one of the few people on LinkedIn that deeply understand what it takes to succeed here. \n\nWe have known each other since her first post which means I have had a front row seat to the journey.\n \nMany folks have come and gone since, but Lara has been one of the few people who stick around. Why? \n\nBecause: \n\n- She is an expert at content creation. \n- She is an expert at community.\n- She is an expert at positioning.\n- She is an expert at branding.\n\nYou don't really need to read my recommendation to find that out. You can just check out her content. \n\nThe community she has built is second to none and it is a testament to her abilities. \n\nIf you are looking to learn content creation or figure out LinkedIn you should get in touch with Lara."
 },
 {
 "recommender_name": "Alex Kottoor",
 "recommender_title": "CRO @ SLS RFID | Founder, Dena Startup Lab (300+ founders) | 3 Exits | Sharing career bumps + breakthroughs",
 "recommender_profile_id": "ACoAAAD0R8UBW2uYA_4D15HMYk4KpMskpMLfICw",
 "recommendation_date": "January 20, 2024",
 "relationship": "Alex was Lara’s client",
 "recommendation_text": "Im a firm believer that those that move with a growth mindset, will not only win more, but will live a more fulfilling life. Lara is clearly winning, and when you couple that with the knowledge she’s continually acquiring and applying, it puts her in a position to create impact for her clients quickly. I unequivocally recommend Lara for anybody trying to step their social game up.\n\nI appreciate the relationship we are building too. \nKeep shining your light bright, Lara."
 },
 {
 "recommender_name": "Jonathan Maharaj FCPA",
 "recommender_title": "Founder | Strategic Finance Advisor | Profit, performance, and leadership in an age of AI",
 "recommender_profile_id": "ACoAAAIxIsMBCEoN28vlGadVjlCXhd9hcHUaU_s",
 "recommendation_date": "January 4, 2024",
 "relationship": "Jonathan was Lara’s client",
 "recommendation_text": "I had a 1:1 coaching session with Lara on my LinkedIn strategy.\n\nLara truly stood out for her approach.\n\nShe was authentic, helpful, and had a great story.\n\nShe’s passionate about personal branding and creating quality content.\n\nAnd the best insight I got was knowing that I was on the right track.\n\nNot only did I learn a lot from our session, I made a friend.\n\n¡Muchísima gracias Lara! \n\nKeep shining your light."
 },
 {
 "recommender_name": "Anthony Carlton",
 "recommender_title": "Founder @ CRE Digital | Helping real estate investors attract deal flow & raise LP capital with brand, content, and AI",
 "recommender_profile_id": "ACoAABEbQHsB0XY709PX4oal2ObJFOncjPF-gTo",
 "recommendation_date": "December 21, 2023",
 "relationship": "Anthony worked with Lara but they were at different companies",
 "recommendation_text": "Lara is a fantastic writer, personal brand consultant, and entrepreneur. I've learned a TON from her daily LinkedIn content. I highly recommend joining her cohort if you want to build an influential personal brand. She is the real deal!"
 },
 {
 "recommender_name": "Qamar Anwar",
 "recommender_title": "MD at First4Lawyers - supplying the UK’s leading law firms with high-quality legal enquiries since 2008. Get in touch to see how we can help your law firm grow in 2025.",
 "recommender_profile_id": "ACoAAAxqFxkBp8inHqqaDVgSbfU2knq1JAa4QwU",
 "recommendation_date": "October 9, 2023",
 "relationship": "Qamar was Lara’s client",
 "recommendation_text": "Lara is a genius! She knows everything there is to know about LinkedIn. She has taught me so much in such a short space of time. Shared so much valuable advice. She has this unique skill which she recently spoke about and I have seen first hand, of being able to reverse engineer a post to make it go viral. I highly recommend Lara for her knowledge, skill and expertise all things LinkedIn and beyond:)"
 },
 {
 "recommender_name": "Charlotte Schulz",
 "recommender_title": "People Professional ",
 "recommender_profile_id": "ACoAABEshDcBYVtcrDGz0f-eZNlTAjAkWBRS8u4",
 "recommendation_date": "September 26, 2023",
 "relationship": "Charlotte was Lara’s client",
 "recommendation_text": "Lara held a workshop for us at Plumm on how to create our personal brand on LinkedIn as individuals. The content, skills and tips that she shared with us were simple and made it easy for us to understand. She shared practical examples and made the workshop engaging for everyone. I would highly recommend using her to up your personal brand game!"
 },
 {
 "recommender_name": "Dakota Robertson",
 "recommender_title": "WorldBranding.com",
 "recommender_profile_id": "ACoAACC_eCABPXMpzYECnNa9svm40_db3wfdQYI",
 "recommendation_date": "September 20, 2023",
 "relationship": "Dakota worked with Lara but they were at different companies",
 "recommendation_text": "Lara knows LinkedIn inside and out. She taught me a ton on best practices and how to navigate it. She also roasts my content on the daily :("
 },
 {
 "recommender_name": "Jasmin Alić",
 "recommender_title": "Award-winning personal branding & business coach | Founder of Link Up community (in 70+ countries) | Teaching you how to build a trusted online brand & profitable business",
 "recommender_profile_id": "ACoAABqlyuoBgq5YAcRF4vz33Y_TOPnD6ASmXZs",
 "recommendation_date": "August 22, 2023",
 "relationship": "Jasmin worked with Lara on the same team",
 "recommendation_text": "When I think \"Lara Acosta\", I think \"inspiring\". Every time I read her stuff, I leave with a new idea."
 },
 {
 "recommender_name": "Sam Szuchan",
 "recommender_title": "Founder, Soleo. Creating influence.",
 "recommender_profile_id": "ACoAADJxmOcB9ewkNVvLueDDab0UxS19_vB0-H0",
 "recommendation_date": "June 1, 2023",
 "relationship": "Sam worked with Lara but they were at different companies",
 "recommendation_text": "It's incredible how naturally that story-rich, engagement-driven content comes to Lara. She seemingly effortlessly crafts all her content to perfection, and any client fortunate enough to work with her ought to count their blessings."
 },
 {
 "recommender_name": "John Harrison",
 "recommender_title": "Senior Content Designer & Product Copywriter | Complex, High-Trust Products | Day-Rate Contracts",
 "recommender_profile_id": "ACoAAAbdk5QBZec1wYxeNjyNMvgDg8Gwqfr8I7I",
 "recommendation_date": "May 22, 2023",
 "relationship": "John worked with Lara but they were at different companies",
 "recommendation_text": "People stay up until 2am in the morning just to speak to Lara. Oh and they pay to do that too. \n\nThat's how good she is. \n\nI've been lucky enough to have some of her time. What I admire the most is how genuine and down to earth she is. Marketing can be an opaque and fluffy world sometimes. Lara demystifies it. \n\nLara's work has become part of my daily routine now. I won't miss what she writes. I genuinely enjoy reading it and I actually learn things. \n\nWhat could be better than that?"
 },
 {
 "recommender_name": "Adam Judeh",
 "recommender_title": "COO / Fractional CTO | opsfx | Building Better Systems for Smarter Companies",
 "recommender_profile_id": "ACoAACX30joB5azP8pme8UA32fI0KDLh-erGcr0",
 "recommendation_date": "May 22, 2023",
 "relationship": "Adam was Lara’s client",
 "recommendation_text": "Best word to describe Lara - EPIC 🤟\n\nI took the leap and booked my 1:1 Power Hour.\n\nLara took the time to pinpoint my obstacles, actually get to know me (not just another lead to check off the list), and gave me clarity on how I’m approaching my personal brand.\n\nWith all the noise of self-starters and people trying to help build LinkedIn brands, I’ve found the most value partnering with Lara. She’s invested in people and their success.\n\nTo me, that’s the most valuable thing on 🌍 \n\nNo matter the niche, I know she’s got your back.\n\nAnd better yet, our whole strategy for my next steps is laid out in a Notion workspace with EVERYTHING we discussed. Gold.\n\nFrom,\n\nA Future Repeat Coaching Client 😊"
 },
 {
 "recommender_name": "Melina Panetta",
 "recommender_title": "I help senior leaders turn 20+ years of expertise into a premium advisory business. | Your corporate career was Act One - let’s build Act Two. | The Modern Founder Method™ | Ex-Oracle, Workday, HP",
 "recommender_profile_id": "ACoAAAE9OYABY7Gg2Unzm7RFuvI-aUMLg3Va7uQ",
 "recommendation_date": "May 22, 2023",
 "relationship": "Melina was Lara’s client",
 "recommendation_text": "I booked a 1:1 with Lara to nail down my content strategy on LinkedIn. She's the REAL deal -- authentic and knows marketing! She listened, educated, and gave me a game plan. I highly recommend working with her, she knows her stuff and you will see results! The best is that I've made a lovely friend who continues to support me. 😊. No matter where you are in your journey, working with her will elevate your business."
 },
 {
 "recommender_name": "Sonia Hunt",
 "recommender_title": "Managing Partner, Zentāra Ventures | Strategic Positioning & Growth Marketing Advisor to Scaling Health Companies | #1 Bestselling Author | TEDx Speaker (1M + views)",
 "recommender_profile_id": "ACoAAAAAfioBZ9Sc_-P9Ib4GOMlSuYFbV6Afko4",
 "recommendation_date": "May 16, 2023",
 "relationship": "Sonia was Lara’s client",
 "recommendation_text": "I've been a fan of Lara's content from day one - it's authentic, poignant, and valuable to the end consumer. I jumped at the chance to be able to work with her on elevating my personal brand's messaging, as sometimes you're just too close to your own brand. Lara has been instrumental in helping me think through strategy, discover areas for improvement, and work with the needs of my business to be able to craft the right messaging that reaches my target audience. I highly recommend working with Lara whether you're just starting out or whether you're a seasoned brand/leader and looking to elevate. It's a rare combo to have someone who understands the changed landscape of marketing and can deliver results early on, and that's Lara!"
 },
 {
 "recommender_name": "Jen Corcoran",
 "recommender_title": "LinkedIn strategist for driven midlife women ✨ Get 5 qualified leads a week in 30 mins a day ✨ No bots, performative posting, or relying on unpredictable word of mouth ✨ 700+ women supported to grow since 2017",
 "recommender_profile_id": "ACoAAAawJi4BnUhFMCYKJiVJw3LT9YlnSjIoi7w",
 "recommendation_date": "May 7, 2023",
 "relationship": "Jen was Lara’s client",
 "recommendation_text": "I recently had a power hour session with Lara and it was great! I'm a LinkedIn Consultant who specialises in profile optimisation and warm organic reach through DMs - content on the home feed has never been my bag. I love learning and thought that Lara could be a great fit for my clients and why not brush up my own content at the same time - win/win! If you need help with your content to start / continue the social selling process you should chat with Lara as she's got it nailed. Her follow up was great too."
 }
 ],
 "recommendations_count": 16,
 "honors_and_awards": [],
 "basic_info": {
 "fullname": "Lara Acosta",
 "first_name": "Lara",
 "last_name": "Acosta",
 "headline": "Entrepreneur and speaker building businesses online | Forbes 30u30 | Helped 3,000+ people grow their personal brand and scale their businesses.",
 "public_identifier": "laraacostar",
 "profile_url": "https://linkedin.com/in/laraacostar",
 "profile_picture_url": "https://media.licdn.com/dms/image/v2/D4E03AQEfwO2tv6ef4A/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1686093441109?e=1779926400&v=beta&t=kQFzGU0rjQ8rqa7Y7dJUoMaTHGei7So4kHpdZT1LgTE",
 "about": "Everyone wants to build a personal brand, and I figured out how.\n\nWith over 20M+ impressions, 300,000 followers across socials, and multiple 6 figures made, I can show you how you can build one too (without spending years figuring out how)\n\nIn 2022: I was unemployed and trying to get into a master's degree - downloaded LinkedIn\nIn 2023: I became #1 female creator on LinkedIn by building my personal brand and agency\nIn 2024: I'm building the best education platform to teach people exactly how to do it\n\nHelped, coached and worked with 500+ build contents systems, increase engagement, improve their writing and beyond using proven strategies that worked for me. \n\nHere's how I can help you:\n\n1. Subscribe to my YouTube (It's free, and better than people's paid courses!)\n2. Join 15,100+ amazing people and subscribe to my newsletter. \n3. Join 500+ members inside Literallyacademy.com\n\nAnd if you're not ready for either! Welcome to my profile anyway, I talk about writing, storytelling, personal branding and tell a lot of stories.\n\nSee you on the feed 💖\n\nSponsorships + booking : mary@ladigitalmx.com or laraacosta@sixteenth.com",
 "location": {
 "country": "United Kingdom",
 "city": "London, England",
 "full": "London, England, United Kingdom",
 "country_code": "GB"
 },
 "creator_hashtags": [
 "copywriting",
 "entrepreneurship",
 "linkedin",
 "personalbranding"
 ],
 "is_creator": true,
 "is_influencer": false,
 "is_premium": true,
 "open_to_work": false,
 "created_timestamp": 1633111304352,
 "show_follower_count": true,
 "background_picture_url": "https://media.licdn.com/dms/image/v2/D4E16AQGGwksybvuaeA/profile-displaybackgroundimage-shrink_350_1400/B4EZx5jLsYH0AY-/0/1771565792830?e=1779926400&v=beta&t=4DYWkCa9ULyOrvTVcQk--WilRIPx-yzTu8SCmkjc6aY",
 "urn": "ACoAADf4bgUB_SYYxrCCxXN6bqAhLp0S6YOWpWU",
 "follower_count": 329718,
 "connection_count": 7649,
 "current_company": "Literally Academy",
 "current_company_urn": "105260514",
 "current_company_url": "https://www.linkedin.com/company/literally-academy",
 "top_skills": [
 "Personal Branding",
 "Content Marketing",
 "Copywriting"
 ],
 "email": "mary@ladigitalmx.com"
 }
 },
 "auditResults": {
 "overallScore": 81,
 "maxScore": 100,
 "sections": {
 "profilePicture": {
 "score": 8,
 "maxScore": 10,
 "current": "Professional headshot present and loaded from LinkedIn CDN.",
 "optimized": [
 "Your ICP is 'Solopreneurs and founders building personal brands on LinkedIn' - they scan for a peer-operator visual (someone who builds, teaches, and ships products), not a distant celebrity.",
 "A creator-educator for founders trades a staged keynote look for workspace context (Literally Academy laptop, whiteboard, course assets) as visual proof of hands-on product experience.",
 "Your current version misses on signalling 'peer operator' via contextual cues (workspace + brand artifacts) rather than pure portrait polish."
 ],
 "suggestions": [
 "Shoot a workspace portrait in your London desk with a visible whiteboard and Literally Academy laptop sticker, wearing a dark blazer over a plain tee.",
 "Crop tightly from mid-chest to top of head with a slight left tilt; aim for a mid-thought expression - peer operator for solopreneurs and founders.",
 "Include a blurred Literally Academy poster or laptop sticker behind you so the brand reads as context, not a prop.",
 "Choose a mid-speech expression (one eyebrow up, not a studio smile) to signal 'operator who teaches' to founders."
 ],
 "priority": "low"
 },
 "banner": {
 "score": 7,
 "maxScore": 10,
 "current": "Custom banner detected.",
 "optimized": [
 "Your banner's single job for solopreneurs and founders is to prove fit in 1-1.5 seconds: audience ('solopreneurs and founders'), outcome (monetisable brand), and your top proof (329K followers, 20M+ impressions, Literally Academy 3,000+).",
 "Lead with one hero line (one claim), one compact proof cluster, and one action; everything else on the banner should support that single message.",
 "Your current version misses on a single, scannable hero line that names the audience + proof."
 ],
 "suggestions": [
 "Put 'I help solopreneurs & founders build monetisable personal brands on LinkedIn - 329K followers • 20M+ impressions' left-justified, white on dark navy, 72pt.",
 "Add subline 'Creator • Forbes 30 Under 30 • Literally Academy - 3,000+ members' right-aligned, 36pt, muted gray.",
 "CTA: 'DM AUDIT' bottom-right, white on signal green, 20pt as a clickable button or QR target.",
 "Feature proof badge '329,718 followers' top-right as a 48px gold circle icon.",
 "Use Canva template 'Creator Banner Pro' 1584×396px, left hero line 72pt, right subline 36pt."
 ],
 "priority": "medium"
 },
 "headline": {
 "score": 8,
 "maxScore": 10,
 "current": "Current headline: \"Entrepreneur and speaker building businesses online | Forbes 30u30 | Helped 3,000+ people grow their personal brand and scale their businesses.\"",
 "optimized": [
 "A headline that converts your ICP must name 'solopreneurs and founders building personal brands on LinkedIn', state the transformation you deliver, and include an immediate credibility cue (Forbes 30U30 or 329K followers).",
 "The high-performing creator headlines pair audience + outcome + quick proof; your current headline shows strong proof but doesn't explicitly name your ICP."
 ],
 "suggestions": [
 "I help solopreneurs and founders build monetisable personal brands on LinkedIn - 329,718 followers • 20M+ impressions • Creator, Literally Academy (3,000+ members)",
 "I teach solopreneurs & founders how to turn LinkedIn attention into revenue - Forbes 30 Under 30 • Creator of Literally Academy • multiple 6-figure launches",
 "I help founders and solopreneurs make LinkedIn their repeatable acquisition channel - 329K followers, 20M+ impressions, cohort programs inside Literally Academy"
 ],
 "priority": "low"
 },
 "about": {
 "score": 8,
 "maxScore": 10,
 "current": "About section: 1135 characters. Snippet: \"Everyone wants to build a personal brand, and I figured out how. With over 20M+ impressions, 300,000 followers across socials, and multiple 6 figures made, I can show you how you can build one too (without spending year…\"",
 "optimized": [
 "Above-the-fold hook must call the ICP by name and present a single transformation - solopreneurs/founders should see 'I help X do Y' in the first line.",
 "Proof should be concentrated (use 329,718 followers, 20M+ impressions, Literally Academy: 3,000+ members) and sit early - then a short bridge to your method and one low-friction CTA.",
 "Your current version lists achievements and multiple CTAs; your current version misses on a tight mini-sales-page flow with one clear CTA."
 ],
 "suggestions": "Most solopreneurs and founders think 'posting more' will fix growth. It doesn't. You need a system that turns attention into repeatable revenue - and that's exactly what I teach.\n\nI build and teach content systems for founders who want a personal brand that works for their business. Across my channels I’ve reached 20M+ impressions and grown an audience of 329,718 people; those systems are refined inside Literally Academy, where 3,000+ members learn the exact content sequence that drives revenue and speaking briefs.\n\nBefore LinkedIn I was starting over; now I run LA Digital (ghostwriting agency) and Literally Academy, run masterclasses with creators like Dakota Robertson, and ship cohort-based programs that move people to paid offers. My work is practical: content frameworks, cohort coaching, and a repeatable launch structure that converts attention into customers.\n\nIf you're a solopreneur or founder building a personal brand on LinkedIn, pick one easy step: DM me 'AUDIT' and I'll give you a free 15-minute profile review with three quick wins you can use this week. If you prefer self-serve, join 15,100+ subscribers on my newsletter or try the free 7-Day LinkedIn Content Plan in Featured.\n\nSponsorships + booking: mary@ladigitalmx.com or laraacosta@sixteenth.com",
 "priority": "low"
 },
 "profileUrl": {
 "score": 9,
 "maxScore": 10,
 "current": "Custom URL: linkedin.com/in/laraacostar",
 "optimized": [
 "Your URL is linkedin.com/in/laraacostar - already custom and memorable; that’s an asset to leverage in external bios, speaker slides, and email signatures.",
 "Most conversion lifts come from using that URL consistently across your content, newsletter, YouTube, and course pages rather than changing it."
 ],
 "suggestions": [
 "Add to email signature: 'Lara Acosta | Founder, Literally Academy | linkedin.com/in/laraacostar' under your name and hyperlink it, 12pt.",
 "Create a QR linking to https://linkedin.com/in/laraacostar and add it to Literally Academy pages and speaker one-sheeters.",
 "Paste 'linkedin.com/in/laraacostar' into your YouTube About, newsletter footer, Instagram bio, and conference slides verbatim.",
 "DM new connections: 'Hey - appreciated your post. My profile: linkedin.com/in/laraacostar - DM \"AUDIT\" for a 15-minute profile review.'",
 "5-minute action: add your URL to the top of Literally Academy course pages and the header of your speaker slide deck."
 ],
 "priority": "low"
 },
 "toneAndCohesion": {
 "score": 8,
 "maxScore": 10,
 "current": "Tone consistency evaluated across headline, About, and Experience sections.",
 "optimized": [
 "Tone and cohesion: every section should tell one story - 'I help solopreneurs and founders build monetisable LinkedIn brands' - and repeat the exact phrase across Headline, Banner, About, Featured, and Experience.",
 "Old or empty entries (Kleo, Angel Investor) create small friction unless they directly support your creator/education offer.",
 "Your current version misses on strict consistency: headline and banner don't use the exact ICP phrase your About and services imply."
 ],
 "suggestions": [
 "Update headline and banner to include the exact phrase 'solopreneurs and founders building personal brands on LinkedIn' to lock cohesion across sections.",
 "Use 'Literally Academy - 3,000+ members' verbatim in Banner, About, and Featured to amplify social proof consistently.",
 "Temporarily condense empty/early-stage Experience entries (Kleo, Angel Investor) into one line until you attach measurable outcomes.",
 "Standardise voice: use present-tense, offer-first lines like 'I help…' across Headline, About, and Experience.",
 "10-minute sanity check: read Headline, Banner, About aloud - if they tell different stories, update the weakest piece to match 'solopreneurs and founders' story."
 ],
 "priority": "low"
 },
 "recommendations": {
 "score": 9,
 "maxScore": 10,
 "current": "16 recommendations on profile from peers and clients.",
 "optimized": [
 "Recommendations are one of your strongest assets: you have many recent, client-facing recs (Hugh Meyer, Qamar Anwar, Alex Kottoor) that match your ICP and should be surfaced as short pull-quotes.",
 "Short, outcome-focused snippets (one line: result + transformation) perform better than long praise when used on your banner and featured slot.",
 "Your current version misses on surfacing 3 short client-result quotes in Featured and Banner."
 ],
 "suggestions": [
 "Message Hugh Meyer: 'Hugh - quick favour: could you write 2 lines about our LinkedIn coaching and the results you saw? Happy to draft.'",
 "Message Qamar Anwar: 'Qamar - could you mention the reverse-engineered post that grew your reach in a short recommendation? I can draft.'",
 "Ask Alex Kottoor and Jonathan Maharaj for a one-line client-result quote usable as a pull-quote on Banner/Featured.",
 "Request each recommender to mention one concrete outcome (engagement lift, cohort signups, revenue) in 1-2 lines.",
 "Schedule: ask 2 recommendations this week, 2 next week; offer to draft the first version to speed replies."
 ],
 "priority": "low"
 },
 "experience": {
 "score": 8,
 "maxScore": 10,
 "current": "4 roles listed. Current: Co-founder at Kleo.",
 "optimized": [
 "Experience should reinforce the offer: current Literally Academy and LA Digital entries already support your audience; keep them outcome-focused and attach case study media.",
 "Condense or temporarily hide entries with empty descriptions (Co-founder, Kleo; Angel Investor) until you add measurable outcomes that support the creator-educator story.",
 "Your current version misses on tight outcome sentences in the Experience bullets that mirror headline/About language."
 ],
 "suggestions": [
 "Replace current role with: 'Founder, Literally Academy - I help solopreneurs and founders build monetisable LinkedIn brands; 3,000+ members, cohort-based curriculum.'",
 "Add '329,718 followers • 20M+ impressions' to the top line of your Literally Academy experience description.",
 "Condense Kleo entry to one line: 'Co-founder, Kleo - early-stage; outcomes to follow' until measurable results exist.",
 "Upload a single case-study PDF to the Literally Academy role showing cohort outcomes (member growth, revenue, engagement).",
 "Swap passive verbs in Experience bullets for 'Built', 'Launched', 'Scaled' to emphasise outcomes."
 ],
 "priority": "low"
 },
 "honorsAndAwards": {
 "score": 8,
 "maxScore": 10,
 "current": "No honors or awards on profile.",
 "optimized": "AI did not return optimization for this section.",
 "suggestions": [],
 "priority": "low"
 },
 "educationAndCertification": {
 "score": 8,
 "maxScore": 10,
 "current": "3 education entries listed.",
 "optimized": [
 "Your MSc in Digital Marketing (University of Exeter, 2022-2023) is a recent, relevant credibility signal for founders learning to market; it belongs near the top of the About proof cluster.",
 "If you have short courses or notable cohort qualifications from Literally Academy instructors (Richard Moore, Dakota Robertson), position them as 'Masterclasses by…' to reinforce the skill network; your current version misses a brief 'credentials + masterclass' line."
 ],
 "suggestions": [
 "Add 'MSc Digital Marketing - University of Exeter (2022-2023)' to the top of Education with 'Merit' shown.",
 "Feature one recent certification or masterclass (e.g., list masterclass leads: Richard Moore, Dakota Robertson) under Literally Academy as 'Masterclasses by…'.",
 "Remove or hide older academic details (A-Levels) from top view; keep University of Exeter prominent as a relevant, recent credential."
 ],
 "priority": "low"
 }
 },
 "prioritizedActions": [
 {
 "title": "Your banner's single job for solopreneurs and founders is to prove fit in 1-1",
 "description": "Your banner's single job for solopreneurs and founders is to prove fit in 1-1.5 seconds: audience ('solopreneurs and founders'), outcome (monetisable brand), and your top proof (329K followers, 20M+ impressions, Literally Academy 3,000+).",
 "timeEstimate": "15-30 min",
 "priority": "medium",
 "category": "banner",
 "impact": "+1-2 points"
 },
 {
 "title": "Your ICP is 'Solopreneurs and founders building personal brands on LinkedIn' - they scan f",
 "description": "Your ICP is 'Solopreneurs and founders building personal brands on LinkedIn' - they scan for a peer-operator visual (someone who builds, teaches, and ships products), not a distant celebrity.",
 "timeEstimate": "15-30 min",
 "priority": "low",
 "category": "profilePicture",
 "impact": "+1-2 points"
 },
 {
 "title": "A headline that converts your ICP must name 'solopreneurs and founders building personal b",
 "description": "A headline that converts your ICP must name 'solopreneurs and founders building personal brands on LinkedIn', state the transformation you deliver, and include an immediate credibility cue (Forbes 30U30 or 329K followers).",
 "timeEstimate": "15-30 min",
 "priority": "low",
 "category": "headline",
 "impact": "+1-2 points"
 },
 {
 "title": "Above-the-fold hook must call the ICP by name and present a single transformation - solopr",
 "description": "Above-the-fold hook must call the ICP by name and present a single transformation - solopreneurs/founders should see 'I help X do Y' in the first line.",
 "timeEstimate": "15-30 min",
 "priority": "low",
 "category": "about",
 "impact": "+1-2 points"
 },
 {
 "title": "Tone and cohesion: every section should tell one story - 'I help solopreneurs and founders",
 "description": "Tone and cohesion: every section should tell one story - 'I help solopreneurs and founders build monetisable LinkedIn brands' - and repeat the exact phrase across Headline, Banner, About, Featured, and Experience.",
 "timeEstimate": "15-30 min",
 "priority": "low",
 "category": "toneAndCohesion",
 "impact": "+1-2 points"
 }
 ],
 "weeklyPlan": [
 {
 "week": 1,
 "focus": "High-impact fixes",
 "tasks": [
 "Polish headline copy",
 "Tighten About opener"
 ],
 "expectedGain": "+8-12 points"
 },
 {
 "week": 2,
 "focus": "Polish + depth",
 "tasks": [
 "Refine banner"
 ],
 "expectedGain": "+5-8 points"
 },
 {
 "week": 3,
 "focus": "Sustained signal",
 "tasks": [
 "Maintain photo",
 "Maintain headline",
 "Maintain About",
 "Ship one outcome-led post per week",
 "Cross-link Featured to About CTAs"
 ],
 "expectedGain": "+3-5 points"
 }
 ]
 }
 },
 {
 "id": "justin-welsh",
 "meta": {
 "headline": "The $10M Solopreneur | One short essay every Saturday on work, money, and building a life you actually choose.",
 "persona": "Justin Welsh · The $10M Solopreneur · 851K followers",
 "score": 81
 },
 "profileUrl": "https://www.linkedin.com/in/justinwelsh/",
 "questionnaireData": {
 "fullName": "Justin Welsh",
 "role": "Solopreneur + creator + educator",
 "industry": "Solopreneur education / creator economy",
 "audience": "Knowledge workers building solo businesses, creators monetizing audience",
 "goal": "Grow direct subscribers to my solopreneur newsletter and courses",
 "tone": "Sharp, contrarian, frameworks-first",
 "biggestRecentImpact": "Built 700K+ LinkedIn audience and an 8-figure solopreneur business with no employees",
 "notes": "Profile is the top of my funnel. Focus is direct subscribers, not vanity metrics."
 },
 "scrapedData": {
 "avatar": "https://media.licdn.com/dms/image/v2/D5603AQEzXKfQMj2sfA/profile-displayphoto-crop_800_800/B56Zzp6fYTHMAQ-/0/1773450953733?e=1779926400&v=beta&t=Bkrb-uFZj1Mscj4SUwlFehCexWWC6F8IAoa0AFdPIVM",
 "profile_picture_url": "https://media.licdn.com/dms/image/v2/D5603AQEzXKfQMj2sfA/profile-displayphoto-crop_800_800/B56Zzp6fYTHMAQ-/0/1773450953733?e=1779926400&v=beta&t=Bkrb-uFZj1Mscj4SUwlFehCexWWC6F8IAoa0AFdPIVM",
 "background_picture_url": "https://media.licdn.com/dms/image/v2/D5616AQHKdTF06Cs9uw/profile-displaybackgroundimage-shrink_350_1400/B56Z2SB1b6KYAY-/0/1776271450606?e=1779926400&v=beta&t=QJk5RwlUyVUq6PX-xOiMEbS0KdpEFjsQDmsn2Jg6fV0",
 "banner_image": "https://media.licdn.com/dms/image/v2/D5616AQHKdTF06Cs9uw/profile-displaybackgroundimage-shrink_350_1400/B56Z2SB1b6KYAY-/0/1776271450606?e=1779926400&v=beta&t=QJk5RwlUyVUq6PX-xOiMEbS0KdpEFjsQDmsn2Jg6fV0",
 "name": "Justin Welsh",
 "fullname": "Justin Welsh",
 "first_name": "Justin",
 "last_name": "Welsh",
 "headline": "The $10M Solopreneur | One short essay every Saturday on work, money, and building a life you actually choose.",
 "position": "The $10M Solopreneur | One short essay every Saturday on work, money, and building a life you actually choose.",
 "public_identifier": "justinwelsh",
 "about": "Over the last decade, I helped build two companies past a $1B valuation and raise over $300M in venture capital. \n\nThen, in 2019, I burned out.\n\nSo, I decided to walk away from my high-paying executive job.\n\nBut, before I could, I had a hypothesis.\n\nI believed building an audience online would be an incredible asset. That attention was the new currency and would play a major part in my success as an entrepreneur.\n\nSo, I started building my brand on LinkedIn in early 2019. \n\nAnd the results were pretty phenomenal.\n\nIn just 6 months, I grew from zero followers to over 20,000.\n\nAnd on August 1st of 2019, I walked away from my executive role at a fast-growing startup.\n\nSince that day, I've spent my time building a number of one-person Internet businesses.\n\nMy results:\n\n→ $12.5M+ in business revenue at a ~86% profit margin.\n→ 800K+ people following my journey on LinkedIn\n→ 560K+ people following my journey on Twitter\n→ 180K+ people read my weekly newsletter\n→ 1B+ impressions in the last 7 years\n\nIf you want to learn more about how I did this, you can take my self-guided masterclass.\n\nTHE CREATOR MBA DIGITAL COURSE\n\nThe Creator MBA teaches you frameworks for turning your knowledge and expertise into a quality product that people will buy. Come learn to build a lean, focused, and profitable Internet business.\n\n→ Start watching here: learn.justinwelsh.me/creator-mba\n\nEmail: support@justinwelsh.me\nX: @thejustinwelsh",
 "city": "New York City Metropolitan Area",
 "country": "United States",
 "country_code": "US",
 "location": "New York City Metropolitan Area",
 "followers": 850503,
 "connections": 29959,
 "follower_count": 850503,
 "connection_count": 29959,
 "is_creator": true,
 "is_premium": true,
 "is_influencer": false,
 "open_to_work": false,
 "current_company": "The Saturday Solopreneur",
 "current_company_url": "https://www.linkedin.com/company/the-saturday-solopreneur",
 "creator_hashtags": [
 "branding",
 "business",
 "entrepreneurship",
 "personalbranding",
 "socialmedia"
 ],
 "top_skills": [],
 "experience": [
 {
 "title": "Writer",
 "company": "The Saturday Solopreneur",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D4E0BAQGM1imXLgtQcg/company-logo_400_400/company-logo_400_400/0/1690307992105/the_saturday_solopreneur_logo?e=1779926400&v=beta&t=-3W2QMquLZQCxa9gb9GkzIZd2ElIP9xCTYjvR_YZXNk",
 "duration": "Jan 2022 - Present · 4 yrs 5 mos",
 "location": "",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/26486924/",
 "description": "",
 "start_date": {
 "month": "Jan",
 "year": 2022
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": []
 },
 {
 "title": "Founder",
 "company": "Justin Welsh",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D4E0BAQG8pfCFIeAd5Q/company-logo_400_400/company-logo_400_400/0/1688384915336/justinwelsh_logo?e=1779926400&v=beta&t=tlSqIWeueSySJE0MajNmqTg3sFbOsPzWwYChtZ_nKPw",
 "duration": "Aug 2019 - Present · 6 yrs 10 mos",
 "location": "",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/98074929/",
 "description": "Practical guidance to help you start and scale your one-person internet business.",
 "start_date": {
 "month": "Aug",
 "year": 2019
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": []
 },
 {
 "title": "Angel Investor",
 "company": "Bonsai Health",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQGAqhefRppywg/company-logo_400_400/B56Zl.KVr9JkAY-/0/1758758263979/bonsaihealth_logo?e=1779926400&v=beta&t=M5vA_rIbQ6isOFF-S_BUvTvE5jMmKIjS8MpSrNgiex4",
 "duration": "Jan 2025 - Present · 1 yr 5 mos",
 "location": "",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/106439250/",
 "description": "",
 "start_date": {
 "month": "Jan",
 "year": 2025
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": []
 },
 {
 "title": "Angel Investor",
 "company": "Kit (formerly ConvertKit)",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQG8QZJUTuXjNQ/company-logo_400_400/company-logo_400_400/0/1727788808425/kitcom_logo?e=1779926400&v=beta&t=yHGh_LpEA4OVoP_DvBh4FcuNJ8zB2vyZJGAiB0-Y3CE",
 "duration": "Nov 2023 - Present · 2 yrs 7 mos",
 "location": "",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/10279376/",
 "description": "",
 "start_date": {
 "month": "Nov",
 "year": 2023
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": []
 },
 {
 "title": "Angel Investor",
 "company": "Spekit",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D4E0BAQHg5LFfw_ubTw/company-logo_400_400/B4EZ3fKfy_KsAY-/0/1777565564432/spekit_logo?e=1779926400&v=beta&t=qjTZyTwHJl15VdfsI_AELMjP8B-ZEgm7d_3ZjoE-tX4",
 "duration": "Dec 2021 - Present · 4 yrs 6 mos",
 "location": "",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/18421890/",
 "description": "",
 "start_date": {
 "month": "Dec",
 "year": 2021
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": []
 },
 {
 "title": "Angel Investor",
 "company": "acquire.com",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/C560BAQGIBh6yp6_q3Q/company-logo_400_400/company-logo_400_400/0/1672882518452/acquiredotcom_logo?e=1779926400&v=beta&t=6LWTm31l5U-QQlIIj4CMWDR7PNtY14jkQgG48aDha3k",
 "duration": "Aug 2021 - Present · 4 yrs 10 mos",
 "location": "",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/30645878/",
 "description": "",
 "start_date": {
 "month": "Aug",
 "year": 2021
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": []
 },
 {
 "title": "Angel Investor",
 "company": "Gumroad",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQERR6ifo8fE_w/company-logo_400_400/B56ZT1kFyHGoAY-/0/1739286666927/gumroad_logo?e=1779926400&v=beta&t=9y_Vrx_aLox2SmxGGqh0gRp0ImXK2e6T4yk1WpQgCj0",
 "duration": "Mar 2021 - Present · 5 yrs 3 mos",
 "location": "",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/2544439/",
 "description": "",
 "start_date": {
 "month": "Mar",
 "year": 2021
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": []
 },
 {
 "title": "Member",
 "company": "Pavilion",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D4E0BAQEp82fIJV1meg/company-logo_400_400/company-logo_400_400/0/1707410857633/join_pavilion_logo?e=1779926400&v=beta&t=8TTqgNAb3t2OTHgJb0Dog3KIHP7ZkKWeuSaGQZ0jjgM",
 "duration": "Jan 2019 - Present · 7 yrs 5 mos",
 "location": "Greater Los Angeles Area",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/27062956/",
 "description": "",
 "start_date": {
 "month": "Jan",
 "year": 2019
 },
 "end_date": {
 "year": null,
 "month": null
 },
 "is_current": true,
 "skills": []
 },
 {
 "title": "Limited Partner",
 "company": "GTMfund",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQG6niaeQefBKA/company-logo_400_400/B56ZqAWtnhHAAY-/0/1763090029313/gtmfund_logo?e=1779926400&v=beta&t=A5m3W_m5FlPA9tpGz8OYFZSr_VtHS6Yfse0wVjzo88w",
 "duration": "Jan 2021 - Dec 2022 · 2 yrs",
 "location": "Austin, Texas Metropolitan Area",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/70877533/",
 "description": "",
 "start_date": {
 "month": "Jan",
 "year": 2021
 },
 "end_date": {
 "month": "Dec",
 "year": 2022
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Mentor",
 "company": "500 Startups Latin America",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/C4E0BAQFlkQuUbLjR_Q/company-logo_400_400/company-logo_400_400/0/1631714425823/500_startups_latin_america_logo?e=1779926400&v=beta&t=dF_zM5lLZLVzl_GCMTpTrIxGdUttUUKrGslePs7LyA4",
 "duration": "Sep 2020 - Dec 2022 · 2 yrs 4 mos",
 "location": "Mexico City Metropolitan Area",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/18330052/",
 "description": "",
 "start_date": {
 "month": "Sep",
 "year": 2020
 },
 "end_date": {
 "month": "Dec",
 "year": 2022
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Strategic Advisor",
 "company": "PatientPop, a Tebra company",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQGJ7vOBj3KdQw/company-logo_400_400/company-logo_400_400/0/1731015683834/patientpop_inc__logo?e=1779926400&v=beta&t=yQ-X2f3lqIkdFOLO-yXCNuu9x3Eo20wQijr0lyKkDvs",
 "duration": "Aug 2020 - Jan 2022 · 1 yr 6 mos",
 "location": "Los Angeles, California, United States",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/3575867/",
 "description": "",
 "start_date": {
 "month": "Aug",
 "year": 2020
 },
 "end_date": {
 "month": "Jan",
 "year": 2022
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Chief Revenue Officer",
 "company": "PatientPop, a Tebra company",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D560BAQGJ7vOBj3KdQw/company-logo_400_400/company-logo_400_400/0/1731015683834/patientpop_inc__logo?e=1779926400&v=beta&t=yQ-X2f3lqIkdFOLO-yXCNuu9x3Eo20wQijr0lyKkDvs",
 "duration": "Jan 2015 - Aug 2020 · 5 yrs 8 mos",
 "location": "Los Angeles Metropolitan Area",
 "employment_type": "Full-time",
 "company_linkedin_url": "https://www.linkedin.com/company/3575867/",
 "description": "Led PatientPop from $0 to over $70M in recurring revenue, and from 1 to over 150 sales employees in 5.5 years. During that time, PatientPop was named:\n\n- Inc. 500 #125 in 2020\n- Deloitte Fast 500 #35 in 2020\n- Consumer World Awards Company of the Year for 2019 \n- Entrepreneur's 3rd most entrepreneurial company of 2019 \n- Entrepreneur's 16th most entrepreneurial company of 2018 \n- One of Silicon Review’s 50 Fastest Growing Companies of 2018 \n- Built In LA's #2 out of 100 best places to work in LA for 2017.",
 "start_date": {
 "month": "Jan",
 "year": 2015
 },
 "end_date": {
 "month": "Aug",
 "year": 2020
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Director, Strategic Sales",
 "company": "ZocDoc",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D4E0BAQGw26vxOtgZtQ/company-logo_400_400/B4EZ4EQA5MKAAY-/0/1778187767713/zocdoc_logo?e=1779926400&v=beta&t=wqLCjtfEGLhPNr9PlbmLwhJv4yzfb-J94zvmKeQ9ZaA",
 "duration": "May 2013 - Feb 2014 · 10 mos",
 "location": "Greater New York City Area",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/167902/",
 "description": "",
 "start_date": {
 "month": "May",
 "year": 2013
 },
 "end_date": {
 "month": "Feb",
 "year": 2014
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Regional Sales Manager",
 "company": "ZocDoc",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D4E0BAQGw26vxOtgZtQ/company-logo_400_400/B4EZ4EQA5MKAAY-/0/1778187767713/zocdoc_logo?e=1779926400&v=beta&t=wqLCjtfEGLhPNr9PlbmLwhJv4yzfb-J94zvmKeQ9ZaA",
 "duration": "Jul 2010 - May 2013 · 2 yrs 11 mos",
 "location": "San Francisco Bay Area",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/167902/",
 "description": "",
 "start_date": {
 "month": "Jul",
 "year": 2010
 },
 "end_date": {
 "month": "May",
 "year": 2013
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Account Executive",
 "company": "ZocDoc",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/D4E0BAQGw26vxOtgZtQ/company-logo_400_400/B4EZ4EQA5MKAAY-/0/1778187767713/zocdoc_logo?e=1779926400&v=beta&t=wqLCjtfEGLhPNr9PlbmLwhJv4yzfb-J94zvmKeQ9ZaA",
 "duration": "Dec 2009 - Jul 2010 · 8 mos",
 "location": "Greater New York City Area",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/167902/",
 "description": "",
 "start_date": {
 "month": "Dec",
 "year": 2009
 },
 "end_date": {
 "month": "Jul",
 "year": 2010
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Surgical Sales Representative",
 "company": "Stryker Endoscopy",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/C4E0BAQHa7kowBO7CeQ/company-logo_400_400/company-logo_400_400/0/1631319537543?e=1779926400&v=beta&t=2vtLcFQGebz9zinVDxeT4RtMHbyqmHtWL92CUlHvcxg",
 "duration": "Nov 2007 - Nov 2009 · 2 yrs 1 mo",
 "location": "",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/3282/",
 "description": "Fired for interviewing with a competitor.",
 "start_date": {
 "month": "Nov",
 "year": 2007
 },
 "end_date": {
 "month": "Nov",
 "year": 2009
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Senior Sales Representative",
 "company": "GlaxoSmithKline",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/C4E0BAQE52m4AbEhxCw/company-logo_400_400/company-logo_400_400/0/1663675238924/glaxosmithkline_logo?e=1779926400&v=beta&t=uoCUsaNKDMCt_H3lVr2kfyRIIM6g4OdwhRmt_OWKLbU",
 "duration": "Nov 2004 - Oct 2007 · 3 yrs",
 "location": "",
 "employment_type": "",
 "company_linkedin_url": "https://www.linkedin.com/company/1399/",
 "description": "Fired.",
 "start_date": {
 "month": "Nov",
 "year": 2004
 },
 "end_date": {
 "month": "Oct",
 "year": 2007
 },
 "is_current": false,
 "skills": []
 },
 {
 "title": "Sales Representative",
 "company": "Biovail",
 "company_logo_url": "https://media.licdn.com/dms/image/v2/C510BAQGv9QM0Bq87Jg/company-logo_400_400/company-logo_400_400/0/1631329283819?e=1779926400&v=beta&t=S0E_OvW6lwQOZEzSSezPGbiRnyqRQewaedfQ1mZYnZ4",
 "duration": "Dec 2003 - Nov 2004 · 1 yr",
 "location": "Steubenville, Ohio, United States",
 "employment_type": "Full-time",
 "company_linkedin_url": "https://www.linkedin.com/company/8711/",
 "description": "Fired.",
 "start_date": {
 "month": "Dec",
 "year": 2003
 },
 "end_date": {
 "month": "Nov",
 "year": 2004
 },
 "is_current": false,
 "skills": []
 }
 ],
 "education": [
 {
 "school": "The Ohio State University",
 "degree": "BSBA, Marketing",
 "degree_name": "BSBA",
 "field_of_study": "Marketing",
 "duration": "1999 - 2003",
 "school_linkedin_url": "https://www.linkedin.com/company/3173/",
 "description": "",
 "activities": "Phi Kappa Tau Fraternity, Project Open Hand, Economics Tutor",
 "skills": [],
 "school_logo_url": "https://media.licdn.com/dms/image/v2/C4E0BAQEw433uw5btkQ/company-logo_400_400/company-logo_400_400/0/1631327096366?e=1779926400&v=beta&t=msXJ2gysa-vn6ryGyQtdRTZqmRJVZfcYtvai6DP14Fw",
 "start_date": {
 "year": 1999,
 "month": null
 },
 "end_date": {
 "year": 2003,
 "month": null
 }
 }
 ],
 "skills": [
 {
 "name": "Content Creation",
 "endorsement_count": 75,
 "related_experiences": []
 },
 {
 "name": "Leadership",
 "endorsement_count": 0,
 "related_experiences": [
 "Endorsed by Kyle A. and 9 others who are highly skilled at this",
 "Endorsed by 5 colleagues at Pavilion"
 ]
 },
 {
 "name": "Sales",
 "endorsement_count": 0,
 "related_experiences": [
 "Endorsed by Brent Dougherty and 7 others who are highly skilled at this",
 "Endorsed by 11 colleagues at Pavilion"
 ]
 },
 {
 "name": "Business Development",
 "endorsement_count": 0,
 "related_experiences": []
 },
 {
 "name": "Copywriting",
 "endorsement_count": 26,
 "related_experiences": []
 },
 {
 "name": "Social Media",
 "endorsement_count": 28,
 "related_experiences": []
 },
 {
 "name": "Sales Management",
 "endorsement_count": 0,
 "related_experiences": []
 },
 {
 "name": "Start-ups",
 "endorsement_count": 87,
 "related_experiences": []
 },
 {
 "name": "Sales Process",
 "endorsement_count": 71,
 "related_experiences": []
 },
 {
 "name": "Sales Operations",
 "endorsement_count": 52,
 "related_experiences": []
 },
 {
 "name": "Strategic Planning",
 "endorsement_count": 53,
 "related_experiences": []
 },
 {
 "name": "Cold Calling",
 "endorsement_count": 31,
 "related_experiences": []
 },
 {
 "name": "Strategy",
 "endorsement_count": 46,
 "related_experiences": []
 },
 {
 "name": "Direct Sales",
 "endorsement_count": 34,
 "related_experiences": []
 },
 {
 "name": "Sales Presentations",
 "endorsement_count": 27,
 "related_experiences": []
 },
 {
 "name": "Healthcare Information Technology",
 "endorsement_count": 18,
 "related_experiences": []
 },
 {
 "name": "New Business Development",
 "endorsement_count": 31,
 "related_experiences": []
 },
 {
 "name": "Product Launch",
 "endorsement_count": 23,
 "related_experiences": []
 },
 {
 "name": "Lead Generation",
 "endorsement_count": 32,
 "related_experiences": []
 },
 {
 "name": "Product Marketing",
 "endorsement_count": 19,
 "related_experiences": []
 },
 {
 "name": "B2B",
 "endorsement_count": 22,
 "related_experiences": []
 },
 {
 "name": "Solution Selling",
 "endorsement_count": 18,
 "related_experiences": []
 },
 {
 "name": "Entrepreneurship",
 "endorsement_count": 41,
 "related_experiences": []
 },
 {
 "name": "CRM",
 "endorsement_count": 13,
 "related_experiences": []
 },
 {
 "name": "Product Development",
 "endorsement_count": 14,
 "related_experiences": []
 },
 {
 "name": "Marketing",
 "endorsement_count": 49,
 "related_experiences": []
 },
 {
 "name": "Business-to-Business (B2B)",
 "endorsement_count": 9,
 "related_experiences": []
 },
 {
 "name": "Customer Relationship Management (CRM)",
 "endorsement_count": 7,
 "related_experiences": []
 },
 {
 "name": "Salesforce.com",
 "endorsement_count": 93,
 "related_experiences": []
 },
 {
 "name": "SaaS",
 "endorsement_count": 26,
 "related_experiences": []
 },
 {
 "name": "Software as a Service (SaaS)",
 "endorsement_count": 14,
 "related_experiences": []
 },
 {
 "name": "Management",
 "endorsement_count": 49,
 "related_experiences": []
 },
 {
 "name": "Team Leadership",
 "endorsement_count": 36,
 "related_experiences": []
 },
 {
 "name": "Strategic Partnerships",
 "endorsement_count": 28,
 "related_experiences": []
 },
 {
 "name": "Strategic Thinking",
 "endorsement_count": 26,
 "related_experiences": []
 },
 {
 "name": "Cross-functional Team Leadership",
 "endorsement_count": 21,
 "related_experiences": []
 },
 {
 "name": "Leadership Development",
 "endorsement_count": 16,
 "related_experiences": []
 },
 {
 "name": "Strategic Leadership",
 "endorsement_count": 15,
 "related_experiences": []
 },
 {
 "name": "Executive Coaching",
 "endorsement_count": 10,
 "related_experiences": []
 },
 {
 "name": "Speaker",
 "endorsement_count": 14,
 "related_experiences": []
 },
 {
 "name": "Experienced Speaker",
 "endorsement_count": 11,
 "related_experiences": []
 },
 {
 "name": "Dynamic Speaker",
 "endorsement_count": 11,
 "related_experiences": []
 },
 {
 "name": "LinkedIn",
 "endorsement_count": 25,
 "related_experiences": []
 },
 {
 "name": "Revenue & Profit Growth",
 "endorsement_count": 7,
 "related_experiences": []
 },
 {
 "name": "Generating Revenue",
 "endorsement_count": 9,
 "related_experiences": []
 },
 {
 "name": "SMB Sales",
 "endorsement_count": 8,
 "related_experiences": []
 },
 {
 "name": "SMB SaaS",
 "endorsement_count": 11,
 "related_experiences": []
 }
 ],
 "certifications": [
 {
 "name": "Google AdWords Search Advertising Certification",
 "organization": "Google",
 "organization_urn": "1441",
 "credential_id": "",
 "issue_date": "Oct 2017",
 "expiration_date": null,
 "skills": [],
 "credential_url": "https://www.google.com/partners/#i_profile;idtf=109327568675494439723;"
 },
 {
 "name": "Google AdWords Certified",
 "organization": "Google",
 "organization_urn": "1441",
 "credential_id": "",
 "issue_date": "Oct 2017",
 "expiration_date": null,
 "skills": [],
 "credential_url": "https://www.google.com/partners/#i_profile;idtf=109327568675494439723;"
 }
 ],
 "featured": [
 {
 "type": "link",
 "title": "Join 180,000+ readers getting one weekly tip to grow their audience and business.",
 "description": "justinwelsh.me",
 "url": "https://www.justinwelsh.me/subscribe",
 "image_url": "https://media.licdn.com/dms/image/sync/v2/D4E27AQGJ4EQrdUqwgQ/articleshare-shrink_1280_800/articleshare-shrink_1280_800/0/1721215757509?e=1778846400&v=beta&t=CRJXFk55Z-VIjn-Xr2_DG2RmHcIugXWud8RperYEBW4"
 },
 {
 "type": "link",
 "title": "Creator MBA Masterclass for building and launching a lean, profitable, one-person business.",
 "description": "learn.justinwelsh.me",
 "url": "https://learn.justinwelsh.me/creator",
 "image_url": "https://media.licdn.com/dms/image/sync/v2/D4D27AQEYUkIBwH2TWw/articleshare-shrink_1280_800/articleshare-shrink_1280_800/0/1737920443291?e=1778846400&v=beta&t=xb02iX1FVZD0KUNyu6mLUQINNBVnK4DlkxBCr-XngUU"
 }
 ],
 "languages": [],
 "volunteering": [],
 "recommendations_received": [
 {
 "recommender_name": "Andrew Tarvin",
 "recommender_title": "Keynote Speaker & Humor Engineer | TEDx 16M+ views | The fastest, funnest path to influence",
 "recommender_profile_id": "ACoAAABs-UEBsRkIXfNr0CtSC9KD5yYnvS_02Ec",
 "recommendation_date": "December 3, 2024",
 "relationship": "Andrew was Justin’s client",
 "recommendation_text": "Justin is fantastic. Between his high quality LI posts and the Creator MBA, I've been able to start building out a second part of my business. Seeking clarity, I booked a 15-minute Intro call with Justin. I was skeptical of how much we could really accomplish in only 15 minutes, but he started dropping knowledge from the start. He gave me a crystal clear plan of action in the first 8 minutes and we even had time to go to a secondary question I had. Regardless of how you interact with him, Justin will always be a positive ROI."
 },
 {
 "recommender_name": "John Kraski",
 "recommender_title": "Partnerships @ Dhar Mann, Forbes #2 Creator I MBA in Entertainment, University of Southern California",
 "recommender_profile_id": "ACoAABkbm-0Be4xxSTDslQoX9c9qcRoExoNAGWk",
 "recommendation_date": "February 20, 2024",
 "relationship": "John was Justin’s client",
 "recommendation_text": "I’m beyond excited to write this recommendation for Justin Welsh. I spent my entire life struggling to build my personal brand and never could figure it out until I found Justin’s work about 5 years ago. Since that time, I’ve purchased all of his courses and also done consulting with him. There’s a lot of people out there telling you how to build your brand on LinkedIn and monetize it but there is only one person that truly delivers results and that is Justin Welsh. The pricing for his products and services are so well priced that everyone that wants to amplify their social media presence can afford them. I highly encourage anyone and everyone looking to level-up their LinkedIn and Twitter games in 2024 and beyond to follow Justin and purchase his courses. The ROI for me has easily been 100x. Trust me this will be the best investment you will ever make in yourself. You’ll thank me later."
 },
 {
 "recommender_name": "Evan H Fisher",
 "recommender_title": "$5B+ raised Series A→IPO | I help tech founders raise their next big round | a16z, Sequoia, SoftBank, Insight, Khosla...",
 "recommender_profile_id": "ACoAAADUOTkBiijcGGsoPsau5i8FvNxRZd91ph0",
 "recommendation_date": "February 1, 2024",
 "relationship": "Evan H was Justin’s client",
 "recommendation_text": "I’ve built a YT following to over 100,000 in under <100 videos - and helped entrepreneurs raise over $5B for their businesses - by focusing on the META (Most Effective Tactics Available). The fastest path to growth, by finding & focusing on the most effective strategies out there. Justin’s Creator MBA provides exactly that for LinkedIn and X (and more). Within two weeks of starting Creator MBA, I had hit my first 50K+ impression post, gained 1,000 followers in a week, got 100+ newsletter signups and MADE MY FIRST SALE. If you don’t have time to waste and want to go straight for your growth path as a creator, you need to get into Creator MBA right now. Stats don’t lie: Justin gave me the META I was looking for. "
 },
 {
 "recommender_name": "Anthony Carlton",
 "recommender_title": "Founder @ CRE Digital | Helping real estate investors attract deal flow & raise LP capital with brand, content, and AI",
 "recommender_profile_id": "ACoAABEbQHsB0XY709PX4oal2ObJFOncjPF-gTo",
 "recommendation_date": "July 28, 2023",
 "relationship": "Anthony worked with Justin but they were at different companies",
 "recommendation_text": "Justin has taught me 90% of the online skills I’ve used to quit my finance job (after burning out multiple times) and build a 6-figure writing business on LinkedIn. At this point I’ll read anything he writes and buy any course he creates. I highly recommend subscribing to The Saturday Solopreneur and learning from Justin’s courses if you want to build digital leverage for yourself."
 },
 {
 "recommender_name": "Walter Haydock",
 "recommender_title": "I help AI-powered companies innovate responsibly by managing cyber, compliance, and privacy risk | ISO 42001, NIST AI RMF, and EU AI Act expert | Host, Deploy Securely Podcast | Harvard MBA | Marine veteran",
 "recommender_profile_id": "ACoAAAi92asBPHnwOwkIF5pefaRXhXuY9j9BFzk",
 "recommendation_date": "December 10, 2022",
 "relationship": "Walter was Justin’s client",
 "recommendation_text": "Justin is the king of LinkedIn! His Operating System (OS) course helped me start my journey as an entrepreneur, giving me the encouragement - and more importantly - the tools to start building an audience online.\n\nWith detailed and actionable frameworks that someone working in any niche can follow, the LinkedIn OS is an excellent tool for those seeking to build an online business. I refer back to it regularly to help hone my craft and improve my content development process.\n\nWithout any experience as a freelancer, I went from zero to five figures in bookings in less than a year using his methods.\n\nI strongly encourage you to give the LinkedIn OS a try!"
 },
 {
 "recommender_name": "Kevin McDonnell",
 "recommender_title": "Chairman | Advisor | Coach - Accelerating growth, scale, and performance. 30 years building, scaling, and exiting companies. 100+ CEOs coached and advised.",
 "recommender_profile_id": "ACoAAABTvCYBOQHui7haj2Xvyd5i2dRMruXoo_k",
 "recommendation_date": "September 20, 2022",
 "relationship": "Kevin worked with Justin but they were at different companies",
 "recommendation_text": "When I decided I needed to get the most from LinkedIn I asked my network whom I should be speaking to. I received a resounding ‘Justin Welsh” and immediately headed over to Justin's profile. I started following him and have never been disappointed. Justin provides tremendous insight, expertise, and value. His course is exceptional - I keep referring to it! If you want to make LinkedIn work for you then I have no hesitation whatsoever in recommending Justin."
 },
 {
 "recommender_name": "Jake Ward",
 "recommender_title": "AI-powered SEO and organic marketing. Co-Founder at Contact (and 3x SaaS companies).",
 "recommender_profile_id": "ACoAACz00cYBIVIrm9Jt-Th9rW7MORz8kljSP70",
 "recommendation_date": "September 12, 2022",
 "relationship": "Jake was Justin’s client",
 "recommendation_text": "I just posted about my first 2 weeks on LinkedIn, where I went from 323 followers to 4,266.\n\nWhilst reflecting and writing the post, it was clear to me that Justin’s content and courses played a pivotal role in my growth on the platform.\n\nJustin laid out the foundations that enabled me to hit the ground running; from how to position my profile to generate leads, to creating great content that drives engagement.\n\nThe Operating System course + jumping into LinkedIn has completely transformed my business. I’ve tripled my inbound leads for this year in only 2 weeks of posting on the platform.\n\nIf you're on the fence, I urge you to also jump in and trust Justin’s process."
 },
 {
 "recommender_name": "Deepak Goyal",
 "recommender_title": "𝗢𝗻 𝗮 𝗠𝗶𝘀𝘀𝗶𝗼𝗻 𝘁𝗼 𝗺𝗮𝗸𝗲 𝟭𝟬𝟬+ 𝗔𝘇𝘂𝗿𝗲 𝗗𝗮𝘁𝗮 𝗘𝗻𝗴𝗶𝗻𝗲𝗲𝗿 𝗶𝗻 𝗻𝗲𝘅𝘁 𝟰𝟱 𝗗𝗮𝘆𝘀",
 "recommender_profile_id": "ACoAAANjjbwBqmZxYq0aHLAt8i6w3x6kfqE1UFM",
 "recommendation_date": "September 3, 2022",
 "relationship": "Deepak was Justin’s client",
 "recommendation_text": "The Operating system is the course which has done wonders to me. I think it is one of the best course I have bought in my entire life. Best think which I like about the course and Justin that, both are very practical, based on reality instead of just status quo. \n\nIt dares me to back my own views and create my own tribe. I had around somewhere 5k-10K follower when I took up his course. I finished the course and started applying his teachings and it done wonders to me. Not only I got 50K+ followers but most importantly the relevant audience who trust me & my work which is helping them out to choose better career opportunities in their life.\n\nThank you, Justin for this amazing stuff. I found my tribe and my own piece of cake!!"
 },
 {
 "recommender_name": "Justin Goodin",
 "recommender_title": "Stress free real estate investing for busy professionals who don’t want to be landlords | Indiana Focused Developer with $58M+ Projects Built",
 "recommender_profile_id": "ACoAACjuETgBhVP_neGNg_x54CrsRfn17RHQmTM",
 "recommendation_date": "August 22, 2022",
 "relationship": "Justin was Justin’s client",
 "recommendation_text": "Just finished the LinkedIn Operating Course. I've already gained more followers in the past week from implementing these principles. The course has great content and is short and to the point."
 },
 {
 "recommender_name": "Maria Franzoni",
 "recommender_title": "More bookings. Higher fees. Faster than you’d expect. I help speakers, bureaus and agents get results. Former international speaker bureau owner and agent. Author of #1 Bestseller The Bookability Formula™",
 "recommender_profile_id": "ACoAAALgPQoBtbke6R-XRRTkHz4SxDHxCF2F8_w",
 "recommendation_date": "August 10, 2022",
 "relationship": "Maria was Justin’s client",
 "recommendation_text": "Since I've applied what I learned on Justin's online courses (I did both), what he shares in his newsletters and on LinkedIn - my content has improved dramatically. In 3 months I have more engagement, it's easier for me to create content that is of value and totally relevant, but best of all I've attracted many new clients. I am seeing the results in my business. Do what Justin says, he knows what he's talking about, he not only talks the talk, he walks the walk. Thank you Justin, I am grateful to Gavin Ingham who recommended you to me."
 },
 {
 "recommender_name": "Caleb Basile, CPA Quality of Earnings",
 "recommender_title": "Buy low, sell high with your favorite QoE guy!",
 "recommender_profile_id": "ACoAABJQJWEB9sUVcNvgz96CUOrVWp8Uot85NS4",
 "recommendation_date": "July 11, 2022",
 "relationship": "Caleb was Justin’s client",
 "recommendation_text": "Own a small business?\n\nJustin's LinkedIn OS Guides you to Convert your LinkedIn Profile to a Living, Breathing Sales Person that works 24/7 for you on a zero dollar salary!\n\nBuy his LinkedIn OS and your Wealth will say, \"Thank You!\"\n\nThe $150 steal would still be worth it at $1,500! \n\nStill unsure? \n\nMessage me.\n\nI'll show you how it transformed my business!"
 },
 {
 "recommender_name": "Sean Rosenboim",
 "recommender_title": "Helping English-speaking families build a clear Aliyah property strategy in Netanya, from uncertainty abroad to keys in hand.🇮🇱",
 "recommender_profile_id": "ACoAACpVp8wB6gEQMeYXpxN1rKaowClGPfOiI4U",
 "recommendation_date": "April 19, 2022",
 "relationship": "Sean was Justin’s client",
 "recommendation_text": "Justin is a force of nature. We got connected less than 6 months ago, and he already earned a place of great respect and appreciation for me. The number of times I read the phrase \"SAVED, as always\" in his posts' comment section(AND saved his posts myself) is countless. He brings phenomenal value and makes every interaction worthwhile. Investing my time and resources with him has been a PERFECT journey so far. 100/100. I know that his LinkedIn OS program is gonna be the last piece of the puzzle for me on my way to changing the industry of influence and thought leadership, and for that, I can't be more grateful. I'm ECSTATIC for what the future will reveal, and for the opportunities to give back to Justin that will reveal themselves."
 },
 {
 "recommender_name": "Shane Arthur",
 "recommender_title": "Helping faith-driven CEO’s lighten the load | Founder, Arthur Coaching",
 "recommender_profile_id": "ACoAABfI_PgBkFEX8v9m_Zu3-9I7Q2__s2R_nFY",
 "recommendation_date": "March 22, 2022",
 "relationship": "Shane was Justin’s client",
 "recommendation_text": "It’s hard to fathom anyone having a wider impact that Justin is having right now. When the dust settles on these early 2020s, thousands of entrepreneurs will have changed their own lives because of Justin’s work and commitment to serving others. I commend his approach and his courses to anyone serious about making an impact on LinkedIn. And candidly, to anyone serious about going out on their own and seeing just what might be possible. "
 },
 {
 "recommender_name": "Jesse Futia",
 "recommender_title": "Systems and Operations Expert for CRE Professionals | $30M+ Raised | 60+ Operators | Co-Founder @ CRE Digital",
 "recommender_profile_id": "ACoAACN93m0BZD_wE8u7Rv29pGO9Qvy_i2pwyDI",
 "recommendation_date": "January 6, 2022",
 "relationship": "Jesse was Justin’s client",
 "recommendation_text": "Justin is an incredible human being. His \"Operating System\" has absolutely changed my life and journey on LinkedIn. His content is incredibly amazing and World Class."
 },
 {
 "recommender_name": "Scott Luscombe",
 "recommender_title": "🤘Rockstar Husband and Dad of 3, Handyman, Graphic Designer, & Shopify Developer.",
 "recommender_profile_id": "ACoAABnyK-wBKpVK7OsF1ccEvMmkUHYezF8f-uU",
 "recommendation_date": "December 20, 2021",
 "relationship": "Scott was Justin’s client",
 "recommendation_text": "I took Justin's LinkedIn Operating System course, about 10 times now. It's such a valuable resource that whenever I come back to it I learn something new. Although the course cost me $150, through LinkedIn posting and networking which I learned during the course, I was able to sign up $135,000 in contracts in December alone. Absolutely invaluable information, thank you Justin!"
 },
 {
 "recommender_name": "Owain Williams - unashamedly in Sales",
 "recommender_title": "Working with businesses to achieve their dream sales results following the D.R.E.A.M methodologies and creating successful sales functions which sell in the Dremur way",
 "recommender_profile_id": "ACoAAAHRzD8Bj0gEUm3cZGGw2t8VWu2lhf9GyRk",
 "recommendation_date": "December 10, 2021",
 "relationship": "Owain Williams was Justin’s client",
 "recommendation_text": "For a brief time, this recommendation will sit at the top and be visible to all before moving down the list as others continue to write deservedly wonderful words about Justin. His journey, content, advice & courses are all amazingly inspirational and genuinely helpful for all those looking to take steps forward in their lives (professional and personal). Connect with Justin, engage, learn and you'll be all the better for it."
 },
 {
 "recommender_name": "Dimeil Ushana",
 "recommender_title": "CCO | GTM Architect | Venture Builder",
 "recommender_profile_id": "ACoAABLjs6cBjmb5lv-n8KOtBqwcIzJK6yxJEWY",
 "recommendation_date": "September 23, 2021",
 "relationship": "Dimeil reported directly to Justin",
 "recommendation_text": "Justin is a very versatile, growth minded revenue leader that objectively develops big picture goals that are tied to measurable metrics and tangible outcomes. His ability to develop frameworks accompanied with his leadership aptitude in guiding teams is unparalleled. I had the opportunity to learn from Justin, and would highly recommend engaging with his courses and his advisory. He is a true go-to-market healthcare delivery leader! "
 },
 {
 "recommender_name": "Jenny Brennan",
 "recommender_title": "Revenue Enablement Leader | Coaching-Led Sales Performance | Scaling GTM Teams",
 "recommender_profile_id": "ACoAAAYsrUcB9V_wmyHl42fGko4ClI4BbXd7AKo",
 "recommendation_date": "September 22, 2021",
 "relationship": "Jenny was Justin’s client",
 "recommendation_text": "3,000 words won’t be enough, but I’ll try and keep it short, honest and helpful. \n\nJustin is the first sales advisor I’ve ever worked with. Up until now, I was muddling along, figuring things out for myself. \n\nIt was slow and painful! \n\nThis year he showed me how to build a solid foundation for hyper growth. Process, people, reporting! \n\nAll I need are the right elements in play, and he showed me how to figure those out for our business myself.\n\nJustin has an honest, direct and common sense approach to business. He never wasted one moment with unnecessary conversations. \n\nEvery session was like a workout for my confidence and helped align my vision for personal and professional success. \n\nIt’s the best investment our company has made this year, and no matter what the future holds, I’m proud of the foundation we’ve built together.\n\nRegardless of where you are on your business growth trajectory, Justin will cut the time it takes to get there by more than half! \n\nSmart, candid, focused and real. Working with Justin is a solid investment for your business and an experience I have great gratitude for! "
 },
 {
 "recommender_name": "Andy Pol Agouridis",
 "recommender_title": "CEO at CareerHigher | Job Search Solutions, Advisory Business Strategy, Global Life Arbitrage | ex-blue-chip, MCIPD, MSc HRM | Greek-born, UK-made, Bangkok-based",
 "recommender_profile_id": "ACoAAAwziE0BZNpYzjK8Wbs4WKMEI-opfHtKlYA",
 "recommendation_date": "August 25, 2021",
 "relationship": "Andy Pol was Justin’s client",
 "recommendation_text": "If you are looking to build an online business, Justin is your man. In a sea of consultants and coaches who overpromise and underdeliver, Justin's advice is valuable, relevant, and on point. After proving he can do it with his own business, he shares all his learnings through A&I and his courses. Also, he's nice, chilled, and down to earth. Highly recommended!"
 },
 {
 "recommender_name": "Ty Frankel",
 "recommender_title": "B2B FOUNDERS: Make $10K-$50K+ a month by booking 5-10+ sales calls/week on LinkedIn | Content isn’t king, DMs are | $4M+ organic sales | Schedule a consultation 👇🏼",
 "recommender_profile_id": "ACoAABfXH7cBxx9wn1GovFlMzB8Yc7JzN1uDdPs",
 "recommendation_date": "August 17, 2021",
 "relationship": "Ty was Justin’s client",
 "recommendation_text": "Justin is THE #1 guy when it comes to building a value-based online presence.\n\nI’ve used Justin’s techniques to grow my Twitter past 22,000 followers, email list to over 6,000, and LinkedIn to almost 3,000.\n\nAnything Justin puts out I click on right away and recommend you do too."
 }
 ],
 "recommendations_count": 20,
 "honors_and_awards": [
 {
 "title": "Speaker at SaaStr Europa 2020",
 "date": "Oct 2019",
 "issuer": "SaaStr",
 "issuer_urn": "26486924",
 "description": "",
 "media_url": ""
 },
 {
 "title": "Speaker at SaaStr Scale 2019",
 "date": "Aug 2019",
 "issuer": "SaaStr",
 "issuer_urn": "26486924",
 "description": "1 of 12 speakers selected to speak at SaaStr Scale 2019 in San Francisco",
 "media_url": ""
 },
 {
 "title": "Speaker at Global Ventures Summit 2018",
 "date": "Oct 2018",
 "issuer": "Global Ventures",
 "issuer_urn": "",
 "description": "The #1 Event Focused on Empowering Scalable Technologies in High Growth Markets",
 "media_url": ""
 },
 {
 "title": "Speaker at SaaStr Annual 2018",
 "date": "Feb 2018",
 "issuer": "SaaStr",
 "issuer_urn": "",
 "description": "",
 "media_url": ""
 },
 {
 "title": "Speaker at MISAC Annual Meeting 2014",
 "date": "Jan 2014",
 "issuer": "",
 "issuer_urn": "",
 "description": "Lectured on the topic, Improving Service Delivery Through Mobile.",
 "media_url": ""
 },
 {
 "title": "ZocDoc President's Club Award Winner 2013",
 "date": "Jan 2013",
 "issuer": "",
 "issuer_urn": "167902",
 "description": "",
 "media_url": ""
 },
 {
 "title": "ZocDoc President's Club Award Winner 2012",
 "date": "Jan 2012",
 "issuer": "",
 "issuer_urn": "167902",
 "description": "",
 "media_url": ""
 },
 {
 "title": "ZocDoc President's Club Award Winner 2011",
 "date": "Jan 2011",
 "issuer": "",
 "issuer_urn": "167902",
 "description": "",
 "media_url": ""
 },
 {
 "title": "ZocDoc President's Club Award Winner 2010",
 "date": "Jan 2010",
 "issuer": "",
 "issuer_urn": "167902",
 "description": "",
 "media_url": ""
 }
 ],
 "basic_info": {
 "fullname": "Justin Welsh",
 "first_name": "Justin",
 "last_name": "Welsh",
 "headline": "The $10M Solopreneur | One short essay every Saturday on work, money, and building a life you actually choose.",
 "public_identifier": "justinwelsh",
 "profile_url": "https://linkedin.com/in/justinwelsh",
 "profile_picture_url": "https://media.licdn.com/dms/image/v2/D5603AQEzXKfQMj2sfA/profile-displayphoto-crop_800_800/B56Zzp6fYTHMAQ-/0/1773450953733?e=1779926400&v=beta&t=Bkrb-uFZj1Mscj4SUwlFehCexWWC6F8IAoa0AFdPIVM",
 "about": "Over the last decade, I helped build two companies past a $1B valuation and raise over $300M in venture capital. \n\nThen, in 2019, I burned out.\n\nSo, I decided to walk away from my high-paying executive job.\n\nBut, before I could, I had a hypothesis.\n\nI believed building an audience online would be an incredible asset. That attention was the new currency and would play a major part in my success as an entrepreneur.\n\nSo, I started building my brand on LinkedIn in early 2019. \n\nAnd the results were pretty phenomenal.\n\nIn just 6 months, I grew from zero followers to over 20,000.\n\nAnd on August 1st of 2019, I walked away from my executive role at a fast-growing startup.\n\nSince that day, I've spent my time building a number of one-person Internet businesses.\n\nMy results:\n\n→ $12.5M+ in business revenue at a ~86% profit margin.\n→ 800K+ people following my journey on LinkedIn\n→ 560K+ people following my journey on Twitter\n→ 180K+ people read my weekly newsletter\n→ 1B+ impressions in the last 7 years\n\nIf you want to learn more about how I did this, you can take my self-guided masterclass.\n\nTHE CREATOR MBA DIGITAL COURSE\n\nThe Creator MBA teaches you frameworks for turning your knowledge and expertise into a quality product that people will buy. Come learn to build a lean, focused, and profitable Internet business.\n\n→ Start watching here: learn.justinwelsh.me/creator-mba\n\nEmail: support@justinwelsh.me\nX: @thejustinwelsh",
 "location": {
 "country": "United States",
 "city": "New York City Metropolitan Area",
 "full": "New York City Metropolitan Area",
 "country_code": "US"
 },
 "creator_hashtags": [
 "branding",
 "business",
 "entrepreneurship",
 "personalbranding",
 "socialmedia"
 ],
 "is_creator": true,
 "is_influencer": false,
 "is_premium": true,
 "open_to_work": false,
 "created_timestamp": 1190652816000,
 "show_follower_count": true,
 "background_picture_url": "https://media.licdn.com/dms/image/v2/D5616AQHKdTF06Cs9uw/profile-displaybackgroundimage-shrink_350_1400/B56Z2SB1b6KYAY-/0/1776271450606?e=1779926400&v=beta&t=QJk5RwlUyVUq6PX-xOiMEbS0KdpEFjsQDmsn2Jg6fV0",
 "urn": "ACoAAAD4GX4BScENIji6QoTu7_m8vC9m_doapuA",
 "follower_count": 850503,
 "connection_count": 29959,
 "current_company": "The Saturday Solopreneur",
 "current_company_urn": "26486924",
 "current_company_url": "https://www.linkedin.com/company/the-saturday-solopreneur",
 "top_skills": [],
 "email": "support@justinwelsh.me"
 }
 },
 "auditResults": {
 "overallScore": 81,
 "maxScore": 100,
 "sections": {
 "profilePicture": {
 "score": 8,
 "maxScore": 10,
 "current": "Professional headshot present and loaded from LinkedIn CDN.",
 "optimized": [
 "For your ICP - \"knowledge workers building solo businesses, creators monetizing audience\" - the picture must read 'peer solopreneur' rather than 'executive speaker'; they trust someone who looks like an operator with a creator habit.",
 "Your profile already anchors to 'Creator MBA' and 'The Saturday Solopreneur' (About and headline); that makes the expected visual code a working-creator in-context, not a studio portrait.",
 "Your current version misses on signaling 'operator-in-workspace' (visual evidence you're a one-person builder, not an abstract thought leader)."
 ],
 "suggestions": [
 "Shoot a workspace portrait: dark charcoal quarter-zip, seated at a desk with laptop and a visible notebook labeled 'Creator MBA'.",
 "Use your actual office background: slightly blurred whiteboard or product wall, monitor at rear-left so it's clearly a builder's desk.",
 "Adopt a 'mid-thought' direct gaze, slight left head tilt, not a posed smile - signal 'operator who ships', attractive to creators and knowledge workers.",
 "Crop tightly from upper chest to top-of-head, left-of-center composition for mobile display; keep face occupying ~40% of frame."
 ],
 "priority": "low"
 },
 "banner": {
 "score": 8,
 "maxScore": 10,
 "current": "Custom banner detected.",
 "optimized": [
 "Your banner needs one readable claim built from your strongest proof: the $12.5M revenue and 800K+ LinkedIn followers - that single claim beats decorative imagery for your ICP.",
 "Because your audience gives the banner ~1.5 seconds, it should be a proof wall: one-line result + Creator MBA name + single CTA (newsletter or masterclass).",
 "Your current version misses on using that hero proof line ('$12.5M' and 'Creator MBA') as the banner's single message."
 ],
 "suggestions": [
 "\"$12.5M+ revenue • 800K+ LinkedIn followers - Creator MBA: Turn your expertise into a profitable one-person business\" - left-justified, white text on dark navy, 72pt hero.",
 "\"Join 180K readers - get one short essay every Saturday: justinwelsh.me/subscribe\" - CTA, bottom-right, 36pt, signal green button.",
 "Feature the exact proof line: \"~86% profit margin on $12.5M+\" as a smaller subhead under the hero line.",
 "Use dark navy background with a single accent in signal green (#00C853) and 2-column layout: hero left, CTA right; use Canva template 'One-Column Course Banner'."
 ],
 "priority": "low"
 },
 "headline": {
 "score": 8,
 "maxScore": 10,
 "current": "Current headline: \"The $10M Solopreneur | One short essay every Saturday on work, money, and building a life you actually choose.\"",
 "optimized": [
 "A headline aimed at knowledge workers building solo businesses must: name that ICP verbatim, state the transformation (profitable one-person business), and anchor with your Creator MBA or $12.5M proof.",
 "Your current headline nails voice and curiosity but misses an explicit ICP callout - that is the lever to convert more of your target audience on sight."
 ],
 "suggestions": [
 "Helping knowledge workers and creators turn expertise into a profitable one-person business - Creator of Creator MBA • $12.5M+ revenue • 800K+ LinkedIn followers",
 "Creator MBA founder - I teach knowledge workers building solo businesses how to monetize audiences and scale to a $10M life (180K newsletter readers, $12.5M+ revenue)",
 "The Saturday Solopreneur - I help creators and knowledge workers build lean, profitable one-person businesses (800K+ followers; $12.5M revenue); join the weekly essay"
 ],
 "priority": "low"
 },
 "about": {
 "score": 9,
 "maxScore": 10,
 "current": "About section: 1430 characters. Snippet: \"Over the last decade, I helped build two companies past a $1B valuation and raise over $300M in venture capital. Then, in 2019, I burned out. So, I decided to walk away from my high-paying executive job. But, before …\"",
 "optimized": [
 "Your About is already a strong mini-case: story hook, growth arc, and specific proofs ($12.5M revenue, 800K+ followers, 180K newsletter). Use the first line to name the ICP explicitly.",
 "The About's CTA points to the Creator MBA masterclass - that conversion stack works; it only needs a clearer above-the-fold invite for \"knowledge workers building solo businesses.\"",
 "Your current version misses on an above-the-fold sentence that directly says: 'If you're a knowledge worker building a solo business, start here.'"
 ],
 "suggestions": "Most people with skill and experience never learn how to turn that advantage into a business that actually supports the life they want. I work with knowledge workers building solo businesses and creators monetizing audiences who want a different path.\n\nYou don’t need a big team or venture capital to build a sustainable business - you need a framework that turns your expertise into a sellable product and a consistent way to attract buyers. That’s what I teach in Creator MBA and what I wrote about in The Saturday Solopreneur.\n\nI built multiple one-person internet businesses after leaving an executive role in 2019. The results: $12.5M+ in business revenue at ~86% profit margin, 800K+ people following my journey on LinkedIn, 180K+ newsletter readers, and 1B+ impressions over the last seven years. Those outcomes are the playbook, not the outlier.\n\nIf you’re a knowledge worker or creator trying to turn expertise into revenue, start with the Creator MBA self-guided masterclass (learn.justinwelsh.me/creator). If you want a quick sanity check, book a 15-minute intro and I’ll give you a concrete next step to grow your audience or product. Email: support@justinwelsh.me - or join 180K readers at justinwelsh.me/subscribe.",
 "priority": "low"
 },
 "profileUrl": {
 "score": 9,
 "maxScore": 10,
 "current": "Custom URL: linkedin.com/in/justinwelsh",
 "optimized": [
 "Your URL is linkedin.com/in/justinwelsh - it's already custom and brand-friendly; leverage it everywhere (email, course pages, QR).",
 "A custom URL removes a basic friction point - now prioritize placement and QR usage rather than changing the URL itself."
 ],
 "suggestions": [
 "Add to email signature: \"Justin Welsh - Creator MBA - https://linkedin.com/in/justinwelsh\" (place under name, 10pt).",
 "Add a QR to the Creator MBA checkout linking to https://linkedin.com/in/justinwelsh with copy \"Connect with me on LinkedIn\".",
 "Paste https://linkedin.com/in/justinwelsh in course welcome emails, newsletter footer, and profile on learn.justinwelsh.me.",
 "DM new course enrollees: \"Hey - I shared a quick profile tip on LinkedIn: https://linkedin.com/in/justinwelsh\" to drive cross-platform trust.",
 "Add the URL to your Twitter/X bio as 'Creator MBA - https://linkedin.com/in/justinwelsh' (immediate cross-platform credibility)."
 ],
 "priority": "low"
 },
 "toneAndCohesion": {
 "score": 9,
 "maxScore": 10,
 "current": "Tone consistency evaluated across headline, About, and Experience sections.",
 "optimized": [
 "All profile sections should repeat 'Creator MBA' and the phrase 'knowledge workers building solo businesses' verbatim so visitors see one coherent offer across headline, banner, About, and Featured.",
 "Old experience details (multiple 'Angel Investor' rows) and odd single-word 'Fired.' notes create tiny contradictions with your current creator story; tidy them to reduce cognitive friction.",
 "Your current version misses on consistent phrase usage across sections - standardize on 'Creator MBA' + 'knowledge workers building solo businesses'."
 ],
 "suggestions": [
 "Standardize the phrase 'Creator MBA' and 'knowledge workers building solo businesses' across headline, banner, About, and Featured.",
 "Move the one-line $12.5M+ / ~86% margin proof to banner, About above-the-fold, and the first featured asset for cohesion.",
 "Condense the multiple 'Angel Investor' experience lines into one 'Angel Investor (selected startups)' entry to reduce noise.",
 "Replace any odd single-word lines in Experience (e.g., 'Fired.') with neutral, curated phrasing or remove if irrelevant.",
 "Run a 10-minute coherence check: open profile in mobile view and confirm the hero banner, headline, and first About line read as one sentence."
 ],
 "priority": "low"
 },
 "recommendations": {
 "score": 9,
 "maxScore": 10,
 "current": "20 recommendations on profile from peers and clients.",
 "optimized": [
 "You have many recent, client-facing recommendations (Andrew Tarvin, John Kraski, Evan H Fisher) - these are high-leverage trust signals for creators and knowledge workers.",
 "Leverage short, outcome-focused excerpts from recent recommendations (2024 Andrew, 2024 John) as pull-quotes in Featured and the About-proof block.",
 "Your current version misses on surfacing short, scannable testimonial pull-quotes tied to Creator MBA outcomes."
 ],
 "suggestions": [
 "Message Andrew Tarvin: \"Andrew - quick favor: could you add a 1-2 sentence recommendation highlighting the Creator MBA result you saw? Happy to draft.\"",
 "Message John Kraski: \"John - can you pin a 2-line quote about ROI from Creator MBA to my profile? I'll draft and send it.\"",
 "Message Evan H Fisher: \"Evan - can you add a one-sentence result (followers/impressions) to your recommendation? Happy to draft.\"",
 "Ask each recommender to mention a specific outcome: followers gained, newsletter signups, or first sale from Creator MBA.",
 "Request 2 new recommendations per month for 6 weeks from recent paying clients to populate Featured pull-quotes."
 ],
 "priority": "low"
 },
 "experience": {
 "score": 7,
 "maxScore": 10,
 "current": "18 roles listed. Current: Writer at The Saturday Solopreneur.",
 "optimized": [
 "Your experience supports authority (PatientPop CRO with $70M ARR growth) but current Founder/Writer entries are light on outcome language tied to Creator MBA.",
 "Condense repeated 'Angel Investor' entries into one line to reduce noise while keeping signal for founders and buyers.",
 "Your current version misses on an outcome-focused current-role blurb that references Creator MBA results and the $12.5M proof."
 ],
 "suggestions": [
 "Replace current Founder description with: \"Creator MBA founder - taught 180K+ readers; built $12.5M+ revenue businesses at ~86% margin; I teach creators to monetize audiences.\"",
 "Add metric to Creator role: \"180K newsletter readers; 800K+ LinkedIn followers; 1B+ impressions in 7 years.\"",
 "Condense repeated Angel Investor entries into one: \"Angel Investor - selected early-stage SaaS & creator tools (2021-Present)\".",
 "Upload a 1-page PDF case study to the Founder role titled 'Creator MBA - $12.5M outcomes' as media.",
 "Swap passive verbs: replace 'Led' with 'Grew' in PatientPop line (e.g., 'Grew PatientPop to $70M ARR')."
 ],
 "priority": "medium"
 },
 "honorsAndAwards": {
 "score": 8,
 "maxScore": 10,
 "current": "9 honors/awards listed.",
 "optimized": "AI did not return optimization for this section.",
 "suggestions": [],
 "priority": "low"
 },
 "educationAndCertification": {
 "score": 6,
 "maxScore": 10,
 "current": "1 education entries listed.",
 "optimized": [
 "Your BSBA, Marketing (Ohio State) is a valid credential but dated - frame it succinctly and move emphasis to recent proof (Creator MBA, course outcomes).",
 "Consider adding one recent, named creator/creator-economy program to signal continuous learning relevant to solopreneur education."
 ],
 "suggestions": [
 "Add a recent, relevant program: 'Reforge Growth Course (recommended) - add as recent learning across Education/Certifications'.",
 "Condense Ohio State listing to: 'BSBA, Marketing - The Ohio State University (1999-2003)' without activities to shorten the block.",
 "Add a continuous-learning signal: 'Pavilion member - highlight Pavilion in Experience or Featured to show active community involvement.'"
 ],
 "priority": "medium"
 }
 },
 "prioritizedActions": [
 {
 "title": "Your BSBA, Marketing (Ohio State) is a valid credential but dated - frame it succinctly an",
 "description": "Your BSBA, Marketing (Ohio State) is a valid credential but dated - frame it succinctly and move emphasis to recent proof (Creator MBA, course outcomes).",
 "timeEstimate": "15-30 min",
 "priority": "medium",
 "category": "educationAndCertification",
 "impact": "+1-2 points"
 },
 {
 "title": "Your experience supports authority (PatientPop CRO with $70M ARR growth) but current Found",
 "description": "Your experience supports authority (PatientPop CRO with $70M ARR growth) but current Founder/Writer entries are light on outcome language tied to Creator MBA.",
 "timeEstimate": "15-30 min",
 "priority": "medium",
 "category": "experience",
 "impact": "+1-2 points"
 },
 {
 "title": "For your ICP - \"knowledge workers building solo businesses, creators monetizing audience\" ",
 "description": "For your ICP - \"knowledge workers building solo businesses, creators monetizing audience\" - the picture must read 'peer solopreneur' rather than 'executive speaker'; they trust someone who looks like an operator with a creator habit.",
 "timeEstimate": "15-30 min",
 "priority": "low",
 "category": "profilePicture",
 "impact": "+1-2 points"
 },
 {
 "title": "Your banner needs one readable claim built from your strongest proof: the $12",
 "description": "Your banner needs one readable claim built from your strongest proof: the $12.5M revenue and 800K+ LinkedIn followers - that single claim beats decorative imagery for your ICP.",
 "timeEstimate": "15-30 min",
 "priority": "low",
 "category": "banner",
 "impact": "+1-2 points"
 },
 {
 "title": "A headline aimed at knowledge workers building solo businesses must: name that ICP verbati",
 "description": "A headline aimed at knowledge workers building solo businesses must: name that ICP verbatim, state the transformation (profitable one-person business), and anchor with your Creator MBA or $12.5M proof.",
 "timeEstimate": "15-30 min",
 "priority": "low",
 "category": "headline",
 "impact": "+1-2 points"
 }
 ],
 "weeklyPlan": [
 {
 "week": 1,
 "focus": "High-impact fixes",
 "tasks": [
 "Polish headline copy",
 "Tighten About opener"
 ],
 "expectedGain": "+8-12 points"
 },
 {
 "week": 2,
 "focus": "Polish + depth",
 "tasks": [
 "Refine experience",
 "Refine education"
 ],
 "expectedGain": "+5-8 points"
 },
 {
 "week": 3,
 "focus": "Sustained signal",
 "tasks": [
 "Maintain photo",
 "Maintain banner",
 "Maintain headline",
 "Ship one outcome-led post per week",
 "Cross-link Featured to About CTAs"
 ],
 "expectedGain": "+3-5 points"
 }
 ]
 }
 }
];

const MATT = SAMPLES.find(s => s.id === 'matt-lakajev');
const LARA = SAMPLES.find(s => s.id === 'lara-acosta');
const JUSTIN = SAMPLES.find(s => s.id === 'justin-welsh');

export const SAMPLE_AUDITS = {
 'matt-lakajev': MATT,
 'lara-acosta': LARA,
 'justin-welsh': JUSTIN,
 // Backward-compat aliases - old URLs at /sample-audit/founder etc. keep working.
 founder: MATT,
 'fractional-cmo': LARA,
 'job-seeker': JUSTIN,
};

export const SAMPLE_AUDIT_LIST = [MATT, LARA, JUSTIN];
